export default {
    "accountValidateMsg" : "La cuenta debe contener de 6 a 30 caracteres, incluidas letras, dígitos y símbolos (\".\", \"_\", \"@\"). El primer carácter debe ser dígito o letra.",
    "storeSuccess" : "La recarga fue un éxito",
    "editAccountTips" : "Por favor ingrese un nombre de cuenta válido",
    "editPwdTips" : "Por favor ingrese una contraseña válida",
    "editRepeatPwdTips" : "Por favor ingresa tu contraseña de nuevo",
    "pwdRepeatTips" : "Las contraseñas no coinciden",
    "changePwdSucc" : "Tu contraseña ha sido cambiada",
    "bindEmail" : "Vincular e-mail",
    "verifyEmail" : "Verificación de seguridad de la cuenta",
    "errorVrifyCodeTips" : "Error de código de verificación",
    "slectQuessionTips" : "Por favor, selecciona una pregunta de seguridad?",
    "answerTips" : "Por favor ingrese la respuesta",
    "twoAnswerTips" : "Por favor seleccione las preguntas de seguridad creadas e ingrese las respuestas correctas",
    "realNameValidateTips" : "Nombre real (4 a 60 caracteres)",
    "phoneValidateTips" : "Número de teléfono (6 a 18 dígitos)",
    "areaSelectTips" : "Por favor selecciona la región",
    "iDCardValidataTips" : "Número de ID (1 a 60 dígitos)",
    "changeProfileSucc" : "Información actualizada guardada",
    "editVrfCodeTips" : "Por favor ingrese el código de verificación",
    "securityQuestionTips" : "Por favor crea preguntas de seguridad para mejorar la seguridad de tu cuenta. Cuando olvidas tu contraseña, puedes responder las preguntas para restablecer la contraseña.",
    "validateQuessionTips" : "Por favor selecciona dos preguntas diferentes y verifique. Puedes recrear las preguntas después de la verificación.",
    "originPwd" : "Contraseña original",
    "newPwd" : "Nueva contraseña",
    "changePwdSuccess" : "Contraseña cambiada. Te sugerimos que vuelves a iniciar sesión ahora mismo para guardar tu progreso.",
    "accountName" : "Nombre de la cuenta",
    "password" : "Ingresa tu contraseña",
    "repeatPassword" : "Por favor repite tu contraseña",
    "findPwdTips" : "Por favor ingrese la cuenta de la cual desea recuperar la contraseña",
    "submit" : "Enviar",
    "send" : "Enviar",
    "modify" : "Modificar",
    "haveAgree" : "De acuerdo",
    "and" : "y",
    "privacyPolicy" : "Política de Privacidad",
    "completeness" : "Finalización",
    "gender" : "Género",
    "male" : "hombre",
    "female" : "mujer",
    "birthday" : "Cumpleaños",
    "phone" : "Telefono",
    "region" : "Región",
    "ID" : "ID",
    "accountSetting" : "Ajustes de cuenta",
    "upgrade" : "Mejorar",
    "profile" : "Perfil",
    "changePassword" : "Cambia Contraseña",
    "securityQuestion" : "Preguntas de Seguridad",
    "creatework_headerTitle" : "Crear Tickete",
    "mylist_headerTitle" : "Mi Tickete",
    "bindEmailTips" : "Verifica tu e-mail para la seguridad de tu cuenta. Si olvidaste tu contraseña, te enviaremos un correo a esta dirección de e-mail.",
    "verifyEmailTips" : "Detectamos que tu cuenta está iniciando sesión desde un dispositivo nuevo o un entorno inusual. Para proteger los activos de tu cuenta, completa la verificación de identidad.",
    "enterEmailVrfcationTips" : "Por favor ingrese el código de verificación aquí.",
    "cancel" : "Rechazar",
    "bindTps" : "¡Vincula tu cuenta para jugar el juego en múltiples dispositivos!",
    "login" : "Iniciar sesión",
    "logout" : "Cerrar sesión",
    "bind" : "Vincular Cuenta",
    "feedback" : "Acuerdos",
    "terms" : "Reacciónes",
    "tips" : "Aviso",
    "debindTips" : "Desvinculación puede provocar la pérdida de datos. ¿Estás seguro de que quieres desvincular?",
    "debindText" : "Desvincular",
    "guestSwitchTips" : "Cuenta de Invitado detectada. Después del inicio de sesión, los datos de su cuenta de invitado se perderán. ¿Continuar?",
    "register" : "Registrarse",
    "realName" : "NombreReal",
    "enterEmailTips" : "Por favor, ingresa tu dirección de e-mail",
    "emailVAlidateMsg" : "email inválido",
    "editEmaileTips" : "Por favor, ingresa tu dirección de e-mail",
    "checkServiceTips" : "Lea primero los Términos de Uso y la Política de Privacidad.",
    "brithdayValidateTips" : "Ingresa tu cumpleaños",
    "facebookValidateTips" : "Cuenta de Facebook (1 a 60 caracteres)",
    "eritOriginPwdTips" : "Contraseña original",
    "submitSuccess" : "Submitted",
    "rebindEmail" : "Cambiar el e-mail vinculado",
    "bindEmailSuccess" : "Email vinculado: \$email</br>Por favor, utiliza un e-mail para verificar. Puede restablecer tu e-mail después de la verificación.",
    "reSetSecurityQuessoon" : "Has creado con éxito las preguntas de seguridad. </br></br>Por favor selecciona diferentes preguntas y verifica. Puedes recrear las preguntas después de la verificación.",
    "canotModifyTips" : "Los cambios NO están permitidos despues de envió, seguro de enviar?",
    "rebindEmailTips" : "Tu E-mail es: \$email, toca aquí para obtener el código de verificación",
    "reGetVrfCode" : "Obtener Código",
    "findPwdWayTips" : "Por favor selecciona una de las siguientes formas",
    "emailWay" : "Recuperar por e-mail de seguridad",
    "emailWayTips" : "Recibirás un correo de confirmación y luego podrás restablecer la contraseña.",
    "quessionWay" : "Recuperar por preguntas de seguridad",
    "quessionWayTips" : "Responde las preguntas de seguridad creadas y luego restablece la contraseña",
    "resetPwdBtn" : "Restablecer la contraseña",
    "lastStep" : "Anterior",
    "sendEmailTips" : "Te hemos enviado un correo a \$email.<br>Por favor ingresa el código de verificación que recibiste aquí.",
    "setNewPwdTips" : "¡Felicidades!<br>ID del usuario verificada. Ahora puedes restablecer tu contraseña.",
    "termsOfUse" : "Términos de Uso",
    "copy_success" : "Copiado",
    "creatework_create" : "Tickete",
    "creatework_createHolder" : "Selecciona Tipo",
    "creatework_title" : "Tema",
    "creatework_titleHolder" : "Por favor ingresa un tema",
    "creatework_detail" : "Detalles",
    "creatework_detailHolder" : "La descripción no debe contener más de 200 caracteres.",
    "creatework_uploadTips" : "Por favor suba archivos jpg/png solamente. El archivo cargado debe ser inferior a 5 MB.",
    "creatework_selectBox_selectTile" : "Tipo",
    "creatework_goGame" : "Volver",
    "creatework_history" : "Historia",
    "mylist_noYet" : "Sin registro",
    "mywork_solved" : "¿Problema resuelto?",
    "mywork_service" : "Nos califica",
    "mywork_messageHolder" : "Nuevo mensaje",
    "mywork_score" : "Puntuación",
    "mywork_confirm" : "CONFIRMAR",
    "creatework_selectBox_selectList3" : "Otro",
    "creatework_selectBox_selectList2" : "Cuenta",
    "close" : "Cerrar",
    "creatework_gameHolder" : "Selecciona un Juego",
    "creatework_serverHolder" : "Elige un servidor",
    "contactService" : "Contacta Servicio al Cliente",
    "FAQ" : "FAQ",
    "creatework_game" : "Juego:",
    "creatework_server" : "Servidor:",
    "creatework_role" : "Personaje:",
    "selectRoleName" : "Selecciona Personaje",
    "creatework_noRole" : "No hay personaje",
    "creatework_noGame" : "Lista de juego vacía",
    "creatework_noServer" : "Lista de servidor vacía",
    "termText" : "Estoy de acuerdo con {mainHost}",
    "backLogin" : "DISMINUCIÓN",
    "creatework_roleHolder" : "Entrar después de elegir tu personaje",
    "findPwdFailTips" : "No has establecido preguntas de seguridad. Por favor, ponte en contacto con servicio al cliente.",
    "payMall" : "Centro Comercial",
    "selectPayment" : "Cantidad",
    "plzSelectPayWay" : "Elegir canal",
    "gainPlus" : "Añadir",
    "gainMorePlus" : "Añadir Más",
    "gainMostPlus" : "Max",
    "plzSelectPayType" : "Seleccione Método de Pago",
    "roleName" : "Personaje",
    "payWay" : "Canal de Pago",
    "plzSelectOtherWay" : "Canal de Pago Alternativo",
    "payment" : "Cantidad",
    "compensateTips" : "El excedente te será devuelto en \$gameCode",
    "extaGain" : "Bono",
    "gameGold" : "Moneda de Juego",
    "compensate" : "Compensación",
    "payWayPlus" : "Bono de Canal",
    "neddPay" : "Pago",
    "submitOrder" : "Enviar",
    "screenshotTips" : "Aviso: haz una captura de pantalla del pedido en caso de que se produzca un error en la transacción.",
    "storeFail" : "Failed to recharge",
    "storeFailTips" : "Transacción fallida. Por favor, envíe el pedido de nuevo o póngase en contacto con nuestro servicio al cliente.",
    "storeAcceptance" : "En proceso",
    "storeSuccessTips" : "La transacción se hará en 15 minutos.",
    "orderNumber" : "N.° del pedido",
    "buyProduct" : "Artículo de recarga",
    "transactionAmount" : "Cantidad",
    "failReason" : "Razón",
    "payOntherORder" : "Orden nueva",
    "reStore" : "Recargar de Nuevo",
    "confirm" : "Confirmar",
    "switch" : "Cambiar Cuenta",
    "completeTips" : "Por favor complete su información personal. <mark class=\"yellowMarkColor\">La información no se podrá editar nuevamente</mark>. Cuando intenta recuperar una cuenta perdida, se le pedirá que proporcione información personal correcta.",
    "creatework_selectBox_selectList0" : "Error del Juego",
    "creatework_selectBox_selectList1" : "Error del Pago",
    "creatework_selectBox_selectList4" : "Error de Traducción",
    "mywork_solvedText" : "Problema resuelto",
    "browserPayErrBtnText" : "Error del Pago",
    "browserPaySucBtnText" : "Pago completado",
    "browserPayingTips" : "Redireccionando a una plataforma de terceros. <br/>Puede cerrar esta página después del pago.",
    "price_list_empty" : "No hay suma aplicable",
    "pointCardTips" : "Nota: Este artículo solo es compatible con la tarjeta \$paymentAmount",
    "forgetPwd" : "¿Olvidaste tu contraseña?",
    "payCenter" : "Centro de Recarga",
    "willGet" : "Conseguirás",
    "goods" : "Artículo",
    "discount" : "Bono",
    "payDiscount" : "Compensación",
    "payDiscountTips" : "El monto excedente será devuelto en la moneda correspondiente.",
    "hasQuestionPlease" : "Si tiene alguna pregunta, por favor",
    "pwdValidateMsg" : "6 a 20 caracteres",
    "payWayPlusC" : "Bono de Canal",
    "fwtk" : "TÉRMINOS DE SERVICIO",
    "yszc" : "POLÍTICA DE PRIVACIDAD",
    "exchange" : "Gift code exchange",
    "remember" : "Recordar mi elección",
    "thirdInfo" : "Sobre cuenta",
    "thirdInfoContent" : "Enlaza tu cuenta en el Centro de usuarios del juego. Después de eso, inicie sesión en el juego utilizando la cuenta vinculada.",
    "unLink" : "Este método actualmente no es compatible",
    "favour" : "Marcador",
    "goStoreTip" : "Por favor, vaya a la página de pago.",
    "go" : "Ir",
    "otherLogin" : "Otros métodos de inicio de sesión",
    "qrCodeTip" : "Escanee el código QR para empezar!",
    "favourTip" : "Marca la página para jugar de nuevo más tarde!",
    "share" : "Compartir",
    "landscapeTip" : "Por favor proceda en modo retrato",
    "leaveTip" : "¿Salir del juego?",
    "selectRole" : "Elige un personaje",
    "selectMoney" : "Elige un accesorio",
    "seletGameInfoFirst" : "Por favor elige el juego",
    "lowerIE" : "IE version too old",
    "linkTermText" : "I have accepted {mainHost} [Terms of Use] and [Privacy Policy]",
    "download" : "Download",
    "favourAndDownloadTip" : "Bookmark this page to browser or download on PC",
    "payReward" : "Recharge Reward",
    "hasEqualReward" : "Double bonus for both payment methods",
    "payBtnText" : "Payment",
    "storeHoaveReward" : "Recharge Bonus",
    "showMorePayWay" : "More Methods",
    "needPaymentCount" : "Amount",
    "orderDetail" : "Details",
    "selectPayWayPlz" : "Choose payment",
    "countryCode" : "Country code",
    "deleteaccount_title1" : "Delete Account",
    "deleteaccount_title2" : "Request account deletion",
    "deleteaccount_step1_1" : "Your account will be frozen for 14 days since the account deletion. After 14 days, your account will be permanently deleted. You will not be able to log in with other social accounts.",
    "deleteaccount_step1_2" : "You may revoke the deletion within the 14 days through the link below:",
    "deleteaccount_step1_3" : "Once deleted, you will not be able to restore your account information. You will not be compensated for any loss caused by account deletion.",
    "deleteaccount_step1_4" : "Are you sure you want to delete your account?",
    "deleteaccount_step2_1" : "Please confirm that you want to delete your account and character.",
    "deleteaccount_step2_2" : "Please type \\&quot;Delete\\&quot; to complete the deletion.",
    "deleteaccount_step3" : "Your account will be deleted in 14 days.",
    "accountrecovery_note" : "Note:",
    "accountrecovery_tips" : "You may only revoke account deletion during the 14-day frozen period.",
    "accountrecovery_Submitted2" : "Revocation submitted. Your account will be restored later.",
    "accountrecovery_Failed" : "Failed",
    "accountrecovery_Failed_1" : "Account status is normal. You may log in.",
    "accountrecovery_Failed_2" : "Character information not found.",
    "accountrecovery_success" : "Account restored",
    "account_normal" : "Account status is normal. No need to restore.",
    "account_unablerestore" : "Account has been deleted. Unable to restore.",
    "accountrecovery_roleHolder" : "Enter  your character name",
    "accountrecovery_headerTitle" : "Revoke Account Deletion",
    "guideTitle" : "Your purchase is not successful. Please contact our customer service.",
    "accountFix" : "Account Recovery",
    "inputAccount" : "Please enter the account name that you wish to recover",
    "applyForAccountFix" : "Account Recovery",
    "nonEnterItem" : "Information to add: Registration Date; Model Number; Device Name; Passport or ID Number, Contact E-mail; Please fill in the blanks",
    "resetOT" : "Time out, please submit the Review again",
    "addOT" : "Time out, please submit the Additional Information again",
    "errorPwd" : "Password has to be 6-20 characters, including letters, numbers, \".\", \"_\", \"@\"",
    "verifyAccount" : "Account info is missing, please check again.",
    "selectRegisterTime" : "Please choose your registration time.",
    "enterBindEmail" : "Please insert your verified email.",
    "enterUsedPhoneType" : "Please insert the model of your mobile phone.",
    "enterIdfaGpid" : "Please insert the UDID of your device.",
    "enterContactEmail" : "Incorrect format of Contact E-mail Address; Please re-enter",
    "confirmTermsPrivacy" : "Please read and agree to the service terms and privacy policy.",
    "enterRechargeRemark" : "Please insert your recharge record.",
    "uploadImg" : "Please upload an Image Scan of your ID, maximum size is 20MB",
    "selectIDType" : "Please select the type of your identification document.",
    "enterIDNum" : "Please insert your passport number or ID number.",
    "enterIP" : "Please insert the IP address you used for registration.",
    "enterQueryNum" : "Please enter Review ID",
    "enterQueryPwd" : "Please enter Review Password",
    "errorQueryItem" : "Incorrect Review ID or Password, please try again",
    "enterPassword" : "Please insert a new password.",
    "enterPasswordAgain" : "Please confirm your new password.",
    "enterPasswordNonSame" : "Inconsistent Password",
    "enterEmail" : "Please enter e-mail address",
    "sendSuccess" : "E-mail has been sent",
    "enterCode" : "Please enter the Verification Code",
    "errorCode" : "Incorrect verification code",
    "selectQuest" : "Please select a Security Question",
    "enterAnswer" : "Please enter the answer",
    "selectDifferQuest" : "Please select 3 Security Questions and answers",
    "addSuccess" : "Your information has been submitted.",
    "picFormt" : "Picture format must be jpg, png or gif",
    "countdownBefore" : "Reset Countdown",
    "countdownAfter" : "(The link will expire at 00:00:00, please submit your application again )",
    "uploadDone" : "Upload done",
    "uploadFail" : "Upload failed",
    "applySuccess" : "Application Approved",
    "applyFailed" : "Application Denied",
    "resetQuestAlterFailed" : "Failed to change security question.",
    "resetQuestError" : "Data input error.",
    "resetQuestNone" : "Inquiry order not found.",
    "resetQuestAltered" : "Security questions have been changed.",
    "illegalOperation" : "Illegal Operation",
    "queryNotExist" : "Inquiry number does not exist.",
    "queryPasswordError" : "Find Password Error",
    "auditing" : "Pending approval",
    "notPass" : "Denied",
    "suppleInformation" : "Submit supplementary information",
    "suppleInformationUnHandle" : "Supplementary information submitted, pending process.",
    "suppleInformationTimeout" : "Submit supplementary information timeout.",
    "repairedAccountSuccess" : "Account repair has been completed.",
    "repairedAccountLost" : "Account repair operation has failed.",
    "loginStateNone" : "Not logged in or session has expired.",
    "repairedAccountTimeout" : "Account repair duration has expired.",
    "changePasswordSucc" : "Password changed.",
    "emailSendFailed" : "Failed to send mail.",
    "emailSendLimit" : "The mailbox may not receive any more verification codes today.",
    "repairedAccountTimeout2" : "Illegal operation account repair duration has expired.",
    "emailCodeSended" : "E-mail verification code has been sent.",
    "alterSuccess" : "Change saved",
    "questionAlterSuccess" : "Security question has been changed.",
    "username" : "Account name",
    "code" : "Please enter the verification code here",
    "selectServiceType" : "Please select Service Type",
    "submitForm" : "Submit the Form",
    "apply" : "Apply",
    "reviewApplicationStatus" : "Review Application Status",
    "instantReviewOfTheStatus" : "Instant Review of the Status",
    "reviewStatus" : "Review Status",
    "backToLogin" : "Back to login",
    "previous" : "Previous",
    "applyDesc" : "Please enter the information so that we can help. You must fill in the blanks with a * . If such information was missing in your account, please enter \"None\".",
    "additionalServices" : "Additional Services",
    "resetSecurityEmail" : "Reset Security E-mail",
    "resetSecurityQuest" : "Reset Security Questions",
    "registrationDate" : "Registration Date",
    "month" : "Month",
    "year" : "Year",
    "emailBound" : "E-mail Bound",
    "modelNumber" : "Mobile model type;",
    "deviceName" : "Device Name",
    "provideRecharge" : "Please provide a detailed and complete Recharge Record, including Time, Method, Amount, Order Number, and Transaction ID for us to confirm.",
    "selectCountry" : "Region",
    "passportID" : "Passport/ ID",
    "upload" : "Upload",
    "del" : "delete",
    "pleaseUpload" : "Please upload an Image Scan of your ID, with maximum size of 20MB",
    "uploadAgain" : "Upload again",
    "enterDesc" : "Please enter any information that proves the ownership of the account",
    "contactEmail" : "Contact E-mail",
    "applyNoteAttr" : "Note",
    "applyNoteDate" : "please provide your e-mail address so that you can receive the results of your application",
    "agree" : "I have agreed to",
    "UJOYTerms" : "Terms of Use",
    "privacy" : "Privacy Policy",
    "reviewStatusOfAccountFix" : "Review Status of Account Fix",
    "enterReviewID" : "Please enter Review ID",
    "enterReviewPwd" : "Please enter Review Password",
    "review" : "Review",
    "reviewNoteAttr" : "Note",
    "reviewNoteData" : "Check your Contact E-mail in case you forgot the Review ID and Review Password",
    "haveResetInfo" : "You\'ve reset your info",
    "resetProfile" : "Reset your Profile",
    "desc" : "¡Felicitaciones! Su verificación ha sido aprobada. Por favor, restablezca su información.",
    "resetAccountDesc" : "Tenga en cuenta: Debe completar todos los elementos de restablecimiento a continuación para desbloquear su cuenta.",
    "changePwd" : "Change Password",
    "resetPwd" : "Reset Password",
    "reset" : "Reset",
    "enterNewPwd" : "Please enter new password",
    "confirmNewPwd" : "Please confirm new password",
    "successResetPwd" : "Successfully Reset password",
    "bindSecurityEmail" : "Bind Security E-mail",
    "resetPwdDesc" : "Reset password when you forgot password or account was stolen",
    "bindCommon" : "Bind",
    "sendCommon" : "Send",
    "enterVcode" : "Please enter the Verification Code",
    "successResetEmail" : "Successfully Reset Security E-mail",
    "resetQuest" : "Reset Security Questions",
    "resetQuestDesc" : "Reset password when you forget your password or you believe your account info was stolen",
    "successResetQuest" : "Successfully Reset Security Questions",
    "hide" : "Hide",
    "addRegisterTime" : "Registration time;",
    "modelNum" : "Model Number: IDFA/GPID",
    "registrationIP" : "Registration IP;",
    "addRechargeRecord" : "Recharge record;",
    "serviceReply" : "Reply from Customer Service:",
    "addDataLimitTime" : "Date for Adding Addititional Information:",
    "addMoreInfo" : "Add More Information",
    "applicationSubmit" : "Application submitted",
    "underReviewStatus" : "Your profile is under review, you will get reply in the next working day. Review status:",
    "reviewID" : "Review ID",
    "reviePwd" : "Review Password",
    "enterReviewIDNPwd" : "Enter Review ID and Review Password to check status",
    "homepage" : "Homepage",
    "checkEmailAttr" : "Note",
    "checkEmailData" : "Check your Contact E-mail in case you forgot your Review ID and Review Password",
    "underReview" : "Under Review",
    "underReviewReply" : "Your profile is under review.We will reply as soon as possible. Thank you for your patience!",
    "failed" : "Application Failed",
    "reason" : "Reason: ### Therefore, application failed, please provide correct information, our staff will help. Thank you for your cooperation!",
    "underReviewAdd" : "Your profile is under review. Part of the information is missing or inconsistent, please add more information for us to confirm!",
    "addInfoRequired" : "Additional Information Required",
    "dateForAddInfo" : "Date for Adding Addititional Information:",
    "addInfo" : "Additional Information",
    "addInfoSubmit" : "Additional Information has been submitted! Thank you for your patience!",
    "hasBeenRepaired" : "Account has been repaired",
    "opExpired" : "Account repair operation expired",
    "approved" : "Approved",
    "haveSubmitted" : "You\'ve submitted",
    "sessionExpired" : "You\'ve not yet logged in or session value has expired",
    "submitted" : "Submitted",
    "addItemRegisterDate" : "E-mail;",
    "addItemDeviceNumber" : "UDID;",
    "reasonItemPwd" : "Inconsistent ID Number;",
    "addItemIDPhoto" : "ID Photo;",
    "idfaTitle" : "How to find your device IDFA or GPID?",
    "idfaSubTitle1" : "For ios user—finding your IDFA",
    "idfaSubTitle1Desc1" : "1.Download the app 【<em>MyIDFA</em>】from App Store",
    "idfaSubTitle1Desc2" : "2.Open this <em>app</em> and you will find your device <em>IDFA</em>.",
    "idfaSubTitle2" : "For Android user—finding your GPID",
    "idfaSubTitle2Desc1" : "1.tab the <em>“settings”</em> button",
    "idfaSubTitle2Desc2" : "2.tab the <em>“Google”</em> icon below the <em>ACCOUNTS</em> page",
    "idfaSubTitle2Desc3" : "3.then tab the <em>“Ads”</em> icon, and you will find your <em>GPID</em>",
    "uploadIDCard" : "Please upload an Image Scan of your ID, with maximum size of 20MB",
    "uploadTipsBefore" : "File size must not be greater than",
    "uploadTipsAfter" : "M",
    "submitError" : "Error caused by missing ID number or wrong account info.",
    "applyLimitError" : "Daily application limit exceeded. (3 times each day)",
    "applyDisabled" : "You may only submit once every 10 minutes.",
    "inputDataError" : "Data is not completed.",
    "dataException" : "Data exception",
    "picSizeLimit" : "Picture file size must not exceed 5MB",
    "picTypeLimit" : "Upload JPG, PNG, GIF files only",
    "picNull" : "Picture is empty",
    "alteredPassword" : "Password has been changed.",
    "inputError" : "Input error.",
    "pwdChangefailed" : "Failed to change password.",
    "sendEmailCodeDisabled" : "Verification code can only be sent again after a period of time.",
    "alteredEmail" : "E-mail has been changed.",
    "inputEmailError" : "E-mail input error",
    "operationFailed" : "Operation failed",
    "codeNull" : "You have not entered a verification code yet.",
    "findPwd" : "Forgot password",
    "findAccountAndPwd" : "Forgot account/password",
    "usualDeviceNum" : "Model Number: IDFA/GPID",
    "usualPhoneNum" : "Device Name",
    "registerTimeError" : "Inconsistent Registration Date;",
    "bindEMailError" : "Inconsistent Bound E-mail;",
    "rechargeRecordError" : "Inconsistent Recharge Record;",
    "registerIPError" : "Inconsistent Registration IP address;",
    "deviceNumError" : "Inconsistent IDFA/GPID;",
    "deviceModelError" : "Inconsistent Device Model;",
    "confirmTerms" : "Please agree to terms of service",
    "applyFixAccount" : "Si ninguno de estos métodos da resultado, puedes solicitar la <span>recuperación de la cuenta</span>;",
    "findPwdByFixAccount" : "You are advised to set a security e-mail for account recovery.",
    "connectFail" : "Disconnected from Google Services, please try again",
    "h5_favour_has_gift" : "Bookmark to browser! (This account has claimed the reward already)",
    "h5_favour_get_gift" : "Congrats! You obtained the reward. Please check in-game.",
    "h5_get_gift_fault" : "Unable to claim. Please try again later, and contact our CS if the problem remains.",
    "h5_favour_please_select" : "Please choose server/character",
    "h5_favour_login_get" : "Log in and bookmark to the browser to claim a reward!",
    "h5_favour_tip" : "Bookmark to the browser to claim a reward!",
    "h5_favour_select_serve" : "Please choose server",
    "h5_favour_select_role" : "Please choose character",
    "store_product_paytype_error" : "You may not purchase the selected item through this payment method.",
    "SwitchWithThirdWay" : "Cambia a \${type}",
    "moreGame" : "Más juegos",
    "serviceTitle" : "Service",
    "h5_download_login" : "Please log in first.",
    "h5_download_tips" : "Please start the game from the client.",
    "h5_download_repeat_get" : "You have claimed this giftpack.",
    "h5_download_succ" : "Please download the client first.",
    "h5_download_repeat_role" : "Character is bound",
    "currentLoginAccount" : "Current account:",
    "fb_canvas_fullscreen" : "Expand",
    "fb_canvas_website" : "Homepage",
    "fb_canvas_like_share" : "Share",
    "fb_canvas_service" : "Support",
    "fb_canvas_login_fail" : "Login failed",
    "fb_canvas_pay_return" : "You have cancelled the transaction",
    "fb_canvas_root_tip" : "Please log in Facebook to authorize first",
    "h5_popup_title" : "Payment way",
    "h5_popup_submit" : "Pay",
    "h5_popup_last_used" : "Last used",
    "h5_popup_quit_tips" : "Are you sure to cancel payment",
    "h5_popup_quit_check" : "YES",
    "h5_popup_quit_cancel" : "NO",
    "h5_popup_currency_sign" : "\$",
    "h5_popup_product_empty" : "Product information has not been obtained yet. Please refresh page",
    "h5_popup_server_empty" : "There is no server list yet. Please refresh page",
    "aboutRelevanceAccount" : "Already have an account?",
    "selectLoginType" : "Select a login method",
    "touristDescription" : "If you already have an account, you can log in as a guest and then use the OTP (One-Time Password) feature in the user center to switch accounts. This feature requires the OTP functionality to be set up on your mobile device in the user center.",
    "touristSuggest" : "If you already have an account, you can log in as a guest and then tap the \"Switch Account\" option in the user center. From there, you can log in using a previously bound social media account.",
    "h5_tourist_remenber" : "Remember me for 14 days",
    "account_czsm1" : "1、全てのゲームデータが新しい端末に引き継がれます。OSの異なる端末で引き継ぐことも可能です；",
    "account_czsm2" : "2、引き継ぐ時のパスワードを登録してください。",
    "account_czsm3" : "3、セキュリティ保護のため、",
    "account_wzfdmm" : "大文字と小文字を区別して、6-16文字のパスワードをご入力",
    "account_qzcsrmm" : "再度パスワードをご入力",
    "account_fxyjm" : "引き継ぎコード発行",
    "account_yjmsm1" : "1、タイトル画面にある「ユーザーセンター」をタップ、「切り替え」のページで引き継ぎを行ってください。",
    "account_yjmsm2" : "2、引き継ぎナンバーに使用期限はございません。",
    "account_yjmsm3" : "3、引き継ぎコードは一度しか使えません。再度引き継ぐことができます。",
    "account_yjmsm4" : "4、アカウントを保護するため、引き継ぎコードを他人に教えないようにしてください。",
    "account_fz" : "コピー",
    "account_cxfx" : "新規で発行する",
    "account_czsm4" : "アカウントを連携",
    "account_czsm5" : "してください。",
    "account_yjm" : "引き継ぎコード",
    "account_16wzzj" : "パスワードの長さは6～16文字にする",
    "account_qsrzqdyjmhmm" : "正しい引き継ぎコードとパスワードを入力してください。",
    "account_yj" : "引き継ぎ",
    "accoun_lcsrdmmbyz" : "パスワードの両回の入力は一致しない",
    "deleteaccount_step3_1" : "within the 14 days. Revoke now?",
    "account_syyjm" : "1. 引き継ぎコードを使ってゲームデータがこの端末に引き継がれます。",
    "account_yjmznsyyc" : "2. 引き継ぎコードは一度しか使えず、再発行することができます。",
    "account_sryjm" : "引き継ぎコードを入力",
    "account_srmm" : "パスワードを入力",
    "h5_header_gift" : "",
    "h5_award_popup_type" : "",
    "h5_award_popup_content" : "",
    "h5_award_popup_code" : "",
    "h5_favour_gift_name" : "",
    "h5_download_gift_name" : "",
    "h5_award_popup_exchange_way" : "",
    "h5_succ_get_gift" : "",
    "h5_exchange_info_title" : "",
    "h5_exchange_info_1" : "",
    "h5_exchange_info_2" : "",
    "h5_check_gift" : "",
    "account_delete_scdqzh" : "¿Estás seguro de que deseas eliminar la cuenta junto con sus datos?",
    "account_delete_fwq" : "Servidor",
    "account_delete_zhm" : "Personaje",
    "account_delete_jshflj" : "Enlace de recuperación de personajes",
    "account_delete_qzyzmdxx" : "(Sensible a mayúsculas y minúsculas)",
    "account_delete_jtbcysxx" : "Se recomienda tomar una captura de pantalla de la información anterior para recuperar la cuenta.",
    "deleteaccount_step3_2" : "After 14 days, your account will be deleted. You will not be able to restore your account. You will lose all your account information.\n\nYou may revoke the account deletion through",
    "h5_guest_login" : "Guest",
    "h5_click_copy" : "",
    "questionnaire_btn" : "questionnaire investigation",
    "h5_header_store_text" : "Recharge",
    "h5_header_home_text" : "Homepage",
    "h5_check_gift_list_text" : "Info de Premios",
    "yourServer" : "Tu servidor",
    "allServer" : "Todos los Servidores",
    "h5_header_screen" : "Pantalla Completa",
    "h5_verticalTip" : "Se recomienda el modo apaisado.",
    "h5_third_party_login_tips" : "If you want to log in using a social media account (such as Facebook, Google, Twitter, etc.), you can first log in as a guest and then bind your social media account in the user center.",
    "webStoreUidTitle" : "",
    "webStoreUidTips" : "",
    "webStoreUidGuide" : "",
    "webStoreUidInputt" : "",
    "feedbackTips" : "",
    "recentPlay" : "Reciente",
    "moreGames" : "Más",
    "previousSelect" : "Previous",
    "payAgainBtn" : "Top-up again",
    "packageTypeName" : "Pack",
    "coinTypeName" : "Top-up",
    "cardTypeName" : "Monthly Card",
    "orderNormal" : "Predeterminado",
    "orderPriceUp" : "Price↑",
    "orderPriceDown" : "Price↓",
    "returnSelectRole" : "Return",
    "jiamaInfo" : "Bonificación del método de pago\nMoneda de la bonificación = Importe abonado*tipo de moneda * tasa de bonificación x Bonificación del método de pago\nMoneda de bonificación = Cantidad abonada*tipo de moneda * tasa de bonificación\n*Aviso: la moneda de bonificación no se tendrá en cuenta durante los eventos de recarga ni en la EXP VIP.*Para los juegos con alcance internacional, el importe del pago se calculará en dólares estadounidenses. Ponte en contacto con el servicio de atención al cliente si tienes dudas al respecto.",
    "lastSelectTag" : "Used previously",
    "onestore_subscribe_manage" : "Manage",
    "onestore_subscribe_entrance" : "OneStore Subscription",
    "onestore_subscribe_has_expire" : "Expired",
    "onestore_subscribe_expire_time" : "Expire on \${month}/\${day}/\${year}",
    "onestore_subscribe_privacy" : "About Subscription and Privacy",
    "onestore_subscribe_cancel_subscribe" : "Cancel Subscription",
    "onestore_subscribe_info_title" : "Subscription Info",
    "onestore_subscribe_option_title" : "Options",
    "onestore_subscribe_do_not_subscribe" : "No subscribed items.",
    "onestore_subscribe_get_role_fail" : "Failed to subscribe. Please open this page again in the game.",
    "onestore_subscribe_later" : "Later",
    "onestore_subscribe_confirm" : "Confirm",
    "onestore_subscribe_confirm_cancel" : "Confirm Cancellation",
    "onestore_subscribe_popup_tip" : "If you cancel now, you can still access your subscription until \${month}/\${day}/\${year}.",
    "onestore_subscribe_detail_tip" : "Subscribed item will be renewed on \${month}/\${day}/\${year} (Price: \${prices}/month). Subscription can be canceled 1 day before it expires.",
    "onestore_subscribe_expired_tip" : "Please subscribe the expired item from the in-game Mall/Shop",
    "onestore_subscribe_goon_sub" : "Renew on \${month}/\${day}/\${year}",
    "onestore_subscribe_has_cancel_tip1" : "Subscription canceled. You can still access your subscription until \${month}/\${day}/\${year}.",
    "onestore_subscribe_has_cancel_tip2" : "If you wish to subscribe again. Please do so in the in-game Mall/Shop.",
    "onestore_subscribe_cancel_fail" : "Failed to cancel subscription. Please try again later.",
    "onestore_subscribe_cancel_fail_title" : "Cancel Subscription",
    "apple_deleteaccount" : "Delete Account",
    "apple_deleteaccount_title" : "Request account deletion",
    "apple_deleteaccount_step1_1" : "Please read the following terms and conditions carefully:",
    "apple_deleteaccount_step1_2" : "Your account will be frozen for 14 days since the account deletion.",
    "apple_deleteaccount_step1_3" : "Your account will be <span class=\"highlight\">permanently deleted</span> if you do not revoke the deletion process in 14 days. Upon deletion of your account, you will not be able to use it to log into the game. All information on your account will be deleted.",
    "apple_deleteaccount_step1_4" : "If you wish to unlink social media account from the account, please contact the customer service team for unlinking operation before deleting your account. Otherwise, upon successful deletion of your account, you will not be able to use your linked social media account to log into the game.",
    "apple_deleteaccount_step1_5" : "Please make sure you have properly disposed your virtual assets in the game before applying for the deletion of your account.<span class=\"highlight\">If you wish to apply for refund, please also do it before deleting your account</span>.",
    "apple_deleteaccount_step1_6" : "You may revoke the deletion within the 14 days through the link below, please save the link in advance:",
    "apple_deleteaccount_step2_1" : "Have you properly disposed your virtual assets in the game? If you haven\'t, please contact the customer service team for the matter before submitting an account deletion request.",
    "apple_deleteaccount_step2_2" : "Please save your server and character information which will be required for restoring your account.",
    "apple_deleteaccount_step2_3" : "Please type \"Delete\" to complete the deletion",
    "apple_deleteaccount_step3_1" : "Your account deletion request has been submitted. The following account is now frozen:",
    "apple_deleteaccount_step3_2" : "We will permanently delete your account after 14 days if there is no further request for revoking the deletion from you.",
    "apple_deleteaccount_step3_3" : "You can visit the following link to revoke the deletion within the 14 days period",
    "apple_deleteaccount_step4_1" : "You have deleted your old account. Please log in with a new account next time.",
    "apple_deleteaccount_agree" : "I have read and agree to the terms and conditions above",
    "apple_deleteaccount_server" : "Server",
    "apple_deleteaccount_roleName" : "Character",
    "copyLink" : "Copy Link",
    "copyTextAndImg" : "please copy and save the link or take a screenshot",
    "copyLinkAndRoleInfo" : "Copy Link & Character",
    "hasCopy" : "Copied to clipboard",
    "quickcard_tips" : "The information of your credit card has been encrypted and secured by Worldpay. The displayed information is only to provide a better experience.",
    "quickcard_use_new_card" : "New credit card",
    "edit" : "Edit",
    "save" : "Save",
    "quickcard_confirm_delete" : "Delete?",
    "quickcard_popup_tip" : "If you want to use this card again after deleting it, please choose the \"New credit card\" option.",
    "quickcard_result_tip_one" : "Si eliges guardar tu número de tarjeta en la página anterior, recogeremos esos datos (**** **** **** 1234) en una versión encriptada.",
    "quickcard_result_tip_two" : "Almacenamos los datos encriptados solo para tu comodidad, y así no tendrás que ingresar los números de la tarjeta en la próxima compra.",
    "quickcard_learn_more" : "Learn more 》",
    "quickcard_info_title" : "Declaraciones sobre las credenciales almacenadas",
    "quickcard_info_tip_one" : "Para proteger mejor los datos de los clientes, Visa y Mastercard están introduciendo nuevas definiciones para estas \"credenciales almacenadas\", así como nuevas normas para las credenciales almacenadas y las transacciones iniciadas por el comerciante.",
    "quickcard_info_tip_two" : "Cuando realizas una compra en nuestro sitio web, recogemos los datos de tu tarjeta (1234 **** **** 1234) en una versión encriptada. Conservaremos los datos encriptados durante 4 años y actualizaremos el acuerdo y la política de privacidad en nuestro sitio web en caso de que haya algún cambio. Almacenamos los datos encriptados solo para tu comodidad, y así no tendrás que ingresar los números de la tarjeta en la próxima compra.",
    "search_product" : "Encontrar artículo",
    "search_price" : "Encontrar precio",
    "price" : "Precio",
    "product_no_found" : "No items are found",
    "price_no_found" : "No price are found",
    "search_no_found" : "No items/price are found",
    "product" : "item",
    "store_tag_hot" : "HOT",
    "store_tag_discount" : "Discount",
    "store_tag_double" : "Double",
    "store_tag_treble" : "Treble",
    "store_tag_sale" : "SALE",
    "store_tag_top_seller" : "TOP SELLER",
    "store_tag_off_10" : "10%OFF",
    "store_tag_off_20" : "20%OFF",
    "store_tag_off_30" : "30%OFF",
    "store_tag_off_40" : "40%OFF",
    "store_tag_off_50" : "50%OFF",
    "store_tag_off_60" : "60%OFF",
    "store_tag_off_70" : "70%OFF",
    "store_tag_off_80" : "80%OFF",
    "store_tag_off_90" : "90%OFF",
    "store_tag_event" : "Event",
    "store_tag_daily" : "Daily",
    "store_tag_weekly" : "Weekly",
    "store_tag_monthly" : "Monthly",
    "subscriptionTypeName" : "subscription",
    "useDoubleSend" : "Use Box Multiplier?",
    "doubleSendInfo" : "Since you used a Box Multiplier, some of the items you purchased were doubled (as shown at the bottom)!",
    "storeRoleTitle" : "Elige un personaje",
    "storeSocialLogin" : "Ingresa con cuentas SNS",
    "storeAccountIdLogin" : "Ingresa con el ID de la cuenta",
    "storeInputId" : "Enter account ID",
    "storeSearch" : "Buscar",
    "storeSelectProductTitle" : "Elige tus ítems",
    "storeInputNameSearch" : "Ingresa el nombre del artículo y busca",
    "storeInputPriceSearch" : "Ingresa el precio del artículo y busca",
    "storeNoFindProduct" : "No se encontró el artículo. Inténtalo de nuevo.",
    "storePriceUp" : "Precio↑",
    "storePriceDown" : "Precio↓",
    "storeLookDetail" : "Detalles",
    "storeChangeProduct" : "Cambiar de artículo",
    "storeWelcome" : "¡Hola",
    "storeLookMore" : "Más",
    "storeHasSelect" : "Artículo seleccionado",
    "storeTotal" : "Total",
    "storeExtra" : "Bonus",
    "storeProductDetail" : "Detalles",
    "storeUidGuideStep1" : "Toca Ajustes > Más > Cuenta",
    "storeUidGuideStep2" : "Ingresa el ID de la cuenta al recargar",
    "storeSelectAndLook" : "Primero elige tu personaje",
    "storeSwitchWay" : "Cambiar el método de inicio de sesión",
    "type1" : "Ofertas Diarias",
    "type2" : "Héroe",
    "type3" : "Maquinaria de Batalla",
    "type4" : "",
    "type5" : "Chip",
    "type6" : "Nova",
    "type7" : "Recursos",
    "type8" : "Aceleración de Construcción",
    "type9" : "Objetos Raros",
    "type10" : "Alianza",
    "type11" : "Diamante",
    "type12" : "Módulo",
    "type13" : "Cubo",
    "type14" : "",
    "type15" : "Nanoarma",
    "type16" : "Gran Premio",
    "type17" : "",
    "type9999" : "Oferta Limitada",
    "type10000" : "Centro de regalos",
    "type10001" : "Eventos de vacaciones",
    "typeother" : "Otros productos",
    "switchChar" : "Cambiar de personaje",
    "howToFindUid" : "¿Cómo encontrar el ID de mi cuenta?",
    "choosePayWay" : "Elige un método de pago",
    "new_apple_deleteaccount_stepsub_title" : "Cancelar la renovación automática",
    "new_apple_deleteaccount_stepsub_1" : "La cuenta tiene activada la subscripción con renovación automática. Se recomienda cancelar esta renovación antes de eliminar la cuenta para evitar cualquier compra involuntaria.",
    "new_apple_deleteaccount_stepsub_2" : "Cancelar la renovación automática",
    "new_apple_deleteaccount_stepsub_later" : "Más tarde",
    "new_apple_deleteaccount_stepsub_now" : "Ahora",
    "new_apple_deleteaccount_title" : "Solicitar eliminación de la cuenta",
    "new_apple_deleteaccount_step1_1" : "Lee atentamente los siguientes términos y condiciones:",
    "new_apple_deleteaccount_step1_2" : "Tu cuenta será <span class=\"highlight\">eliminada de manera permanente</span> una vez que la borres. Ya no podrás usarla para ingresar al juego. Tampoco se podrá recuperar la información de la cuenta que haya sido eliminada.",
    "new_apple_deleteaccount_step1_3" : "Si deseas desvincular tu cuenta de las redes sociales, ponte en contacto con el equipo de atención al cliente antes de eliminar tu cuenta para poder realizar esta operación. De lo contrario, una vez eliminada tu cuenta, ya no podrás utilizar las redes sociales vinculadas a la cuenta para ingresar al juego. Asegúrate, también, de haber eliminado correctamente los activos virtuales del juego antes de solicitar la eliminación de tu cuenta.",
    "new_apple_deleteaccount_step1_4" : "<span class=\"highlight\">También recuerda pedir los reembolsos antes de eliminar tu cuenta. </span>Asegúrate de haber eliminado correctamente tus activos virtuales antes de eliminar tu cuenta.",
    "new_apple_deleteaccount_step2_1" : "¿Has eliminado correctamente los activos virtuales del juego? Si no lo has hecho, ponte en contacto con el equipo de atención al cliente para que te lo solucionen antes de que envíes la solicitud para eliminar tu cuenta.",
    "new_apple_deleteaccount_step2_2" : "Teclea \"Delete\" para completar la eliminación. La eliminación de la cuenta no puede ser revocada una vez ejecutada.",
    "new_apple_deleteaccount_step2_3" : "Teclea \"Delete\" para completar la eliminación",
    "new_apple_deleteaccount_step3_1" : "Se ha enviado la solicitud para eliminar tu cuenta. La siguiente cuenta ha sido eliminada:",
    "new_apple_deleteaccount_step3_2" : "Crea una cuenta nueva si quieres volver a ingresar al juego.",
    "new_apple_deleteaccount_step4_1" : "Has eliminado tu cuenta anterior. La próxima vez ingresa con una cuenta nueva.",
    "currencyTypeName" : "Moneda",
    "has_select_product" : "Tus artículos:",
    "n_product" : "\${n}",
    "look_detail_product" : "Ver todo",
    "limit_buy_product" : "Límite de compra para este artículo: \${n}",
    "limit_order" : "Puedes comprar un máximo de \${n} artículos por vez.",
    "limit_order_remove_tip" : "Has alcanzado el límite de compra de algunos de los artículos del carrito. ¿Quieres eliminarlos?",
    "paytype_limit" : "No se puede usar este método de pago para comprar algunos de los artículos que tienes. Elige otro o intenta comprarlos por separado.",
    "check_remove_cart" : "¿Eliminar del carro?",
    "remove_cart" : "Eliminar",
    "confirm_product" : "Confirmar",
    "select_paytype" : "Elegir método de pago",
    "cart_is_empty_tip" : "No se encontraron artículos. Elige uno.",
    "thirty_tip" : "Si los artículos que compraste no llegan en los próximos 30 minutos, ponte en contacto con el servicio de atención al cliente.",
    "total_n_product" : "Artículo x\${n}",
    "look_detail_of_cart" : "Ver todo",
    "order_detail" : "Lista de artículos",
    "total_detail" : "Cantidad:",
    "add_to_cart" : "Agregar al carro",
    "back_to_select" : "Volver",
    "fail_and_later" : "Item info error. Please try again later.",
    "nextStep" : "Confirmar",
    "pnsGameName" : "Puzzles & Survival",
    "enterOfficial" : "Visitar \nsitio web",
    "visitorLogin" : "Invitado",
    "tokenLogin" : "OTP",
    "fbLogin" : "Iniciar sesión con Facebook",
    "googleLogin" : "Iniciar sesión con Google",
    "twitterLogin" : "Iniciar sesión con Twitter",
    "vkLogin" : "Iniciar sesión con VK",
    "agreementTextStart" : "Al iniciar sesión en el juego, confirmas que has leído y aceptado los Términos del servicio y las Políticas de privacidad.",
    "userCenter" : "Centro del usuario",
    "welcomeBack" : "¡Hola de nuevo!",
    "continueGame" : "INICIAR",
    "officialPay" : "Centro de recarga",
    "changeAccount" : "Cambiar de cuenta",
    "back" : "Volver",
    "tokenKey" : "OTP",
    "inputUid" : "Ingresa tu ID de usuario",
    "inputToken" : "Ingresa tu OTP",
    "inputCkCode" : "Escribe el texto",
    "enterGame" : "INICIAR",
    "tokenTip" : "Protege tu cuenta con la verificación OTP",
    "howToGetToken" : "¿Cómo consigo mi contraseña de un solo uso (OTP)?",
    "getStep1" : "Paso 1: Ve a Ajustes > Cuenta > Centro del usuario",
    "getStep2" : "Paso 2: Toca la opción \"OTP\"",
    "getStep3" : "Paso 3: Copia tu ID de usuario y la contraseña de un solo uso e ingrésalos",
    "copy" : "Copiar",
    "lastRefresh" : "Se actualiza en:",
    "second" : "s",
    "immediatelyRefresh" : "Actualizar ahora",
    "frequently" : "Operación demasiado frecuente. Inténtalo de nuevo más tarde.",
    "loginFail" : "Error al iniciar sesión. Contraseña incorrecta.",
    "tokenIntro" : "Acerca de la contraseña de un solo uso (OTP)",
    "tokenIntro1" : "1. Las contraseñas de un solo uso caducan en 120 segundos. Úsalas con cuidado para mantener tu cuenta segura y protegida.",
    "tokenIntro2" : "2. El equipo de nunca te pedirá tu contraseña de un solo uso. No compartas tu contraseña con nadie.",
    "nextStep1" : "Confirmar",
    "couponCanUse" : "Utilizable",
    "couponCanNotUse" : "No utilizable",
    "couponHasNoCoupon" : "No hay cupones",
    "couponUseTip" : "Usa 1 cupón por pedido",
    "couponValidTime" : "Validez",
    "couponFuilCanUse" : "Se puede usar con pedidos que superen los \${price} \${currency}",
    "couponNoLimit" : "No hay limitaciones",
    "couponAllProductCanUse" : "Todos los artículos",
    "couponPartProductCanUse" : "Artículos específicos",
    "couponPartPaytypeCanUse" : "Canales de pago específicos",
    "couponOnlyCoinCanUse" : "Solo para la moneda del juego",
    "couponOnlyDiamondCanUse" : "Solo para diamantes",
    "couponOnlyPackageCanUse" : "Solo para paquetes",
    "couponOnlySubCanUse" : "Solo para suscripciones",
    "couponOnlyDaibiCanUse" : "Solo para las fichas",
    "couponMaxDiscount" : "Descuento de hasta \${price} \${currency}",
    "couponHasUsed" : "Utilizado",
    "couponReductionType" : "Deducción",
    "couponDiscountType" : "Descuento",
    "couponUseNow" : "Usar",
    "couponHasNoSelect" : "No se está usando ningún cupón",
    "couponHasSelectQuan" : "Con descuento",
    "couponSubmitTip" : "Se utilizarán los cupones",
    "couponCanUseQuan" : "Cupones",
    "couponOrderTotal" : "Total",
    "couponHasDiscount" : "Descuento",
    "couponPayTotal" : "Pago",
    "couponCancel" : "Cancelar",
    "couponConfirm" : "Confirmar",
    "uidLoginName" : "Iniciar sesión con OTP",
    "uidToken" : "OTP",
    "uidInputUid" : "Ingresa tu ID de usuario",
    "uidInputToken" : "Ingresa tu OTP",
    "uidInputCode" : "Escribe el texto",
    "uidTipTitle" : "Protege tu cuenta con la verificación OTP",
    "uidTipHowToGet" : "¿Cómo consigo mi contraseña de un solo uso (OTP)?",
    "uidTipStep1" : "Paso 1: Ve a Ajustes > Cuenta > Centro del usuario",
    "uidTipStep2" : "Paso 2: Toca la opción \"OTP\"",
    "uidTipstep3" : "Paso 3: Copia tu ID de usuario y la contraseña de un solo uso e ingrésalos",
    "uidTipIntro1" : "1. Las contraseñas de un solo uso caducan en 60 segundos. Úsalas con cuidado para mantener tu cuenta segura y protegida.",
    "uidTipIntro2" : "2. El equipo de nunca te pedirá tu contraseña de un solo uso. No compartas tu contraseña con nadie.",
    "couponMyQuan" : "Cupones",
    "couponSelectPaytypeTip" : "Selecciona el canal de pago para ver la información de los descuentos",
    "couponSelectCouponTip" : "Selecciona los cupones para ver el precio con descuento",
    "couponValidQuanTip" : "(Cupones x\${num} utilizables)",
    "couponLookCart" : "Carrito",
    "couponUnfoldCart" : "Ocultar",
    "couponCoupon" : "Cupón",
    "couponNoUse" : "Sin usar",
    "couponSelect" : "Seleccionar cupón",
    "couponSureUse" : "Usar",
    "couponReturn" : "Volver",
    "couponInvalidTime" : "Vencimiento",
    "couponBuyNow" : "Comprar ahora",
    "couponAllType" : "all",
    "ztmslgType1" : "Ofertas Diarias",
    "ztmslgType2" : "Héroe",
    "ztmslgType3" : "Maquinaria de Batalla",
    "ztmslgType4" : "",
    "ztmslgType5" : "Chip",
    "ztmslgType6" : "Nova",
    "ztmslgType7" : "Recursos",
    "ztmslgType8" : "Aceleración de Construcción",
    "ztmslgType9" : "Objetos Raros",
    "ztmslgType10" : "Alianza",
    "ztmslgType11" : "Diamante",
    "ztmslgType12" : "Módulo",
    "ztmslgType13" : "Cubo",
    "ztmslgType14" : "",
    "ztmslgType15" : "Nanoarma",
    "ztmslgType16" : "Gran Premio",
    "ztmslgType17" : "Núcleo",
    "ztmslgType9999" : "Oferta Limitada",
    "ztmslgType10000" : "Centro de regalos",
    "ztmslgType10001" : "Eventos de vacaciones",
    "ztmslgTypeother" : "Other",
    "antslgType1" : "Oferta Diaria",
    "antslgType2" : "Hormiga Especializada",
    "antslgType3" : "Equipamiento",
    "antslgType5" : "Gen",
    "antslgType6" : "Caracol",
    "antslgType7" : "Recursos",
    "antslgType8" : "Construcción e Investigación",
    "antslgType9" : "Artículos Raros",
    "antslgType10" : "Alianza",
    "antslgType11" : "Diamante",
    "antslgType12" : "Célula",
    "antslgType13" : "Tótem",
    "antslgType9999" : "Oferta Limitada",
    "antslgTypeother" : "other",
    "typeall" : "Todos los productos",
    "vipHead" : "Puntos VIP",
    "vipHead213": "Membresía Premium",
    "vipTitle" : "Evento de Puntos VIP",
    "nowLevel" : "Tu nivel:",
    "myVipScore" : "Tus pts:",
    "nextLevelNeed" : "(Gana \${num} puntos más para obtener VIP \${level})",
    "ruleTitle" : "Reglas:",
    "ztmslgVipRule1" : "1. El evento empieza a las 00:00 (UTC) 22/09/2022",
    "ztmslgVipRule2" : "2. Juegos disponibles:  Puzzles & Survival",
    "ztmslgVipRule3" : "Cada tipo de recompensa del evento solo se puede reclamar una vez.",
    "ztmslgVipRule4" : "3. Evento de cupón de inicio de sesión: Si inicias sesión por primera vez en la página de recarga, podrás reclamar un cupón de descuento del 15%.",
    "ztmslgVipRule5" : "4. Evento \"Puntos VIP\": compra ítems en nuestra página oficial para ganar puntos y obtener cupones de nivel y semanales.",
    "ztmslgVipRule6" : "5. Los puntos que obtengas pueden variar según la moneda que utilices. Para más detalles, consulta el enlace que aparece al final.",
    "ztmslgVipRule7" : "6. Al usar los cupones, ganarás puntos según la cantidad que hayas pagado una vez descontados los cupones.",
    "ztmslgVipRule8" : "7. Los puntos que hayas ganado caducarán en 365 días. Esto podría afectar tu nivel VIP.",
    "ztmslgVipRule9" : "8. Recibirás un cupón por alcanzar un nivel VIP por primera vez. El cupón semanal se podrá reclamar todos los sábados a las 00:00 (UTC+0).",
    "ztmslgVipRule10" : "9. Tendrás que iniciar sesión para poder reclamar el cupón semanal. ¡No te lo pierdas!",
    "ztmslgVipRule11" : "10. La moneda del cupón será la del último pedido que hayas realizado. Ponte en contacto con el servicio de atención al cliente si deseas cambiar la moneda del cupón.",
    "ztmslgVipRule12" : "11. Consulta la siguiente tabla para ver más detalles sobre los cupones y los niveles VIP.",
    "ztmslgVipRule13" : "12. Si se produce algún conflicto, el equipo de asistencia de Puzzles & Survival tendrá autoridad absoluta para interpretar las Condiciones Generales.",
    "vipLevel" : "Nivel VIP",
    "vipCondition" : "Pts requeridos",
    "firstSend" : "Regalo por primera vez",
    "weeklySend" : "Cupón semanal",
    "lastAllCoupon" : "Cupones del nivel anterior",
    "besides" : "Tabla de Puntos/Moneda:",
    "couponRatio" : "Tasa de Puntos/Monedas",
    "backToPay" : "VOLVER",
    "quanGift" : "CUPÓN",
    "quanGiftTips" : "¡Tienes cupones para reclamar!",
    "antslgVipRule1": "Pronto el evento \"Puntos VIP\" dejará de estar disponible debido a una actualización de funciones.",
    "antslgVipRule2": "Asegúrate de utilizar los cupones que hayas obtenido en \"Puntos VIP\" antes de que caduquen.",
    "antslgVipRule3": "Hora de finalización: 28/09/2024 00:00:00 (UTC)",
    "antslgVipRule4": "Puedes visitar el Centro de Miembros Premium cuando termine el evento para disfrutar de más ventajas:",
    "antslgVipRule5": "Completa las misiones para ganar puntos y canjearlos por cupones, objetos del juego y otras recompensas. Aprovecha las ventajas exclusivas para miembros y los sorteos.",
    "antslgVipRule6": "¡No te pierdas los próximos premios y eventos!",
    "dzgVipRule0" : "1. El evento empieza a las 00:00 (UTC) 27/09/2022",
    "dzgVipRule1" : "1. Juegos disponibles: \${gameName}",
    "dzgVipRule2" : "Cada tipo de recompensa del evento solo se puede reclamar una vez.",
    "dzgVipRule3" : "2. Evento de cupón de inicio de sesión: Si inicias sesión por primera vez en la página de recarga, podrás reclamar un cupón de descuento del 15%.",
    "dzgVipRule4" : "3. Evento \"Puntos VIP\": compra ítems en nuestra página oficial para ganar puntos y obtener cupones de nivel y semanales.",
    "dzgVipRule5" : "4. Los puntos que obtengas pueden variar según la moneda que utilices. Para más detalles, consulta el enlace que aparece al final.",
    "dzgVipRule6" : "5. Al usar los cupones, ganarás puntos según la cantidad que hayas pagado una vez descontados los cupones.",
    "dzgVipRule7" : "6. Los puntos que hayas ganado caducarán en 365 días. Esto podría afectar tu nivel VIP.",
    "dzgVipRule8" : "7. Recibirás un cupón por alcanzar un nivel VIP por primera vez. El cupón semanal se podrá reclamar todos los sábados a las 00:00 (UTC+0).",
    "dzgVipRule9" : "8. Tendrás que iniciar sesión para poder reclamar el cupón semanal. ¡No te lo pierdas!",
    "dzgVipRule10" : "9. La moneda del cupón será la del último pedido que hayas realizado. Ponte en contacto con el servicio de atención al cliente si deseas cambiar la moneda del cupón.",
    "dzgVipRule11" : "10. Consulta la siguiente tabla para ver más detalles sobre los cupones y los niveles VIP.",
    "dzgVipRule12" : "11. Si se produce algún conflicto, el equipo de asistencia de \${gameName} tendrá autoridad absoluta para interpretar las Condiciones Generales.",
    "213dzgVipRule1" : "Pronto el evento \"Puntos VIP\" dejará de estar disponible debido a una actualización de funciones.",
    "213dzgVipRule2" : "Asegúrate de utilizar los cupones que hayas obtenido en \"Puntos VIP\" antes de que caduquen.",
    "213dzgVipRule3" : "Hora de finalización: 19/08/2024 08:00:00 (UTC)",
    "213dzgVipRule4" : "Puedes visitar el Centro de Miembros Premium cuando termine el evento para disfrutar de más ventajas:",
    "213dzgVipRule5" : "Completa las misiones para ganar puntos y canjearlos por cupones, objetos del juego y otras recompensas. Aprovecha las ventajas exclusivas para miembros y los sorteos.",
    "213dzgVipRule6" : "¡No te pierdas los próximos premios y eventos!",
    "getReward" : "Exclusive avatar frames",
    "unbindEntry" : "Vincular/Desvincular cuenta",
    "unbindApply" : "Desvincular",
    "unbindConfirmTitle" : "¿Realmente quieres desvincular la cuenta?",
    "unbindConfirmTip" : "Podrías perder las partidas guardadas o el progreso del juego si desvinculas la cuenta.",
    "unbindConfirm" : "Desvincular de todos modos",
    "unbindExit" : "Salir",
    "unbindSucc" : "Cuenta desvinculada",
    "unbindFail" : "No se pudo desvincular la cuenta. Contacta al servicio de atención al cliente.",
    "unbindServiceTitle" : "Solicita una desvinculación manual.",
    "unbindContact" : "Servicio de atención al cliente",
    "unbindServiceTip" : "No puedes desvincular la cuenta. Contacta al servicio de atención al cliente.",
    "antslgType15" : "Legado",
    "shareEventTitle" : "Invita a tus amigos</br>\nY gana recompensas",
    "shareRule" : "Reglas",
    "awardBag" : "Mi recompensa",
    "initiatorText" : "Yo soy quien invita",
    "inviteeText" : "Soy invitado",
    "createCode" : "Crear un código de invitación",
    "createCodeTip" : "Toca para crear un código de invitación",
    "createLinkTip" : "Toca para crear un enlace de invitación",
    "copyText" : "Copiar",
    "shareCode" : "Compartir el código de invitación",
    "twShare" : "",
    "fbShare" : "",
    "dcShare" : "",
    "seeAward" : "Ver recompensa",
    "seeAwardTip" : "Ve tus recompensas en <span class=\"see-light\">Punto VIP</span> > <span class=\"see-light\">Mi cupón</span>.",
    "inviteReward" : "Recompensa por Invitación",
    "inviteRewardTip" : "La persona que invita solo podrá reclamar estas recompensas cuando cada invitado logra cumplir estos objetivos por primera vez",
    "overweightReward" : "Recompensa bonus",
    "resetTip" : "Se reinicia a las 00:00 del último día de cada mes.",
    "rewardText1" : "Recarga total por la persona invitada: \$9.99",
    "rewardText2" : "Recarga total por la persona invitada: \$49.99",
    "rewardText3" : "Recarga total por la persona invitada: \$99.99",
    "rewardText4" : "Obtener Cupones de descuentos del 12% x1 por cada 5 jugadores invitados",
    "rewardText5" : "Obtener Cupones de descuentos del 15% x1 después de que los invitados recarguen un total de \$1000",
    "invitationList" : "Mi invitación",
    "refresh" : "Actualizar",
    "invitedTotal" : "Invitado: \${total}",
    "storedTotal" : "Recarga total: \${total}",
    "people" : "",
    "invitedPeople" : "Invitado",
    "invitedTime" : "Invitado",
    "got" : "Logrado",
    "get" : "No logrado",
    "overlay" : "Acumulable",
    "couponText" : "Cupón",
    "personalReward" : "Recompensa de la recarga",
    "personalRewardText1" : "La recarga total llega a los \$9.99",
    "personalRewardText2" : "La recarga total llega a los \$49.99",
    "personalRewardText3" : "La recarga total llega a los \$99.99",
    "inputCode" : "Ingresa el código de invitación",
    "bindCode" : "Confirmar",
    "bindSucc" : "Vincular",
    "codeTip1" : "El código no existe.",
    "codeTip2" : "Código de invitación vinculado",
    "copySucc" : "¡Exitoso!",
    "awardName" : "Recompensa",
    "getTime" : "Obtenido",
    "getCondition" : "Requisitos",
    "couponText1" : "Cupón de descuento del 6%",
    "couponText2" : "Cupón de descuento del 8%",
    "couponText3" : "Cupón de descuento del 10%",
    "couponText4" : "Cupón de descuento del 12%",
    "couponText5" : "Cupón de descuento del 15%",
    "ruleText1" : "1. Hora de inicio del evento: 25/11/2022, 00:00 UTC",
    "ruleText2" : "2. Juego del evento: Puzzles & Survival",
    "ruleText3" : "3. Evento \"Compartir el sitio de recarga oficial\": Comparte este sitio de recarga oficial con tus amigos e invítalos a recargar. Si recargan una cierta cantidad a través de esta página, recibirás una recompensa.",
    "ruleText4" : "4. Recompensas mensuales de pagos de terceros: Completa los objetivos mensuales de compartir para ganar recompensas. Las recompensas de compartir se reinician todos los meses.",
    "ruleText5" : "5. Para obtener las recompensas mensuales, se requiere que al menos uno de los jugadores que has invitado pague con exitoso la recarga.",
    "ruleText6" : "6. Las recompensas mensuales se reinician el primer día de cada mes. También se reinicia cualquier progreso del mes pasado.",
    "ruleText7" : "7. El cupón recompensado se debe reclamar iniciando sesión en el sitio de recarga de terceros. Si este caduca, recuerda que no podrás recibir otro.",
    "ruleText8" : "8. El cupón usa la misma moneda que has utilizado en recargas anteriores.",
    "ruleText9" : "9. No puedes usar el código de invitación de otro jugador si este ya ha utilizado el tuyo.",
    "ruleTableTitle1" : "Reglas：",
    "ruleTableTitle2" : "Explicación de los niveles VIP y los Cupones:",
    "ruleTableHead1" : "Requisitos de la recarga",
    "ruleTableHead2" : "Requisitos de la recompensa",
    "ruleTableHead3" : "Recompensas",
    "ruleTableContent1" : "Invitar a 5 jugadores nuevos",
    "ruleTableContent2" : "Jugadores invitados, recarga de \$1000 USD",
    "errorTip" : "Falló la operación",
    "eventShareText1" : "Ofertas por tiempo limitado de Puzzles & Survival",
    "eventShareText2" : "¡Te esperan un montón de regalos!",
    "cartDoubleTip" : "Los Multiplicadores de Cajas no son compatibles.",
    "codeTip3" : "No se ha iniciado sesión",
    "codeTip4" : "Falta el parámetro",
    "codeTip5" : "No puedes vincular tu propio código de invitación",
    "codeTip6" : "Se ha creado un código de invitación",
    "payWelfare" : "Regalo de Recarga",
    "wallet" : "Billetera",
    "myDiscount" : "Mi cupón",
    "knowMore" : "Más",
    "backPay" : "Volver",
    "curBalance" : "Saldo",
    "pay" : "Recargar",
    "changeCoin" : "Cambiar de moneda",
    "watchDesc" : "Ver detalles",
    "getMore" : "Obtener más",
    "getDiscount" : "Reclamar tus cupones",
    "notOpenDiscountQuan" : "No hay eventos. ¡Está atento a las novedades!",
    "abountZbit" : "Sobre \${Z-BIT}",
    "remain" : "Restante:",
    "payRemain" : "Cantidad que queda después de la compra:",
    "payRemainExpiry" : "Saldo estimado tras el pago: ${money} (Caduca el 1 de enero de 2026, úselo pronto)",
    "balanceNotEnoughExpiry" : "Saldo insuficiente (Caduca el 1 de enero de 2026, no se admiten recargas)",
    "balanceNotEnoggh" : "No hay suficiente saldo. Primero recarga.",
    "goToPay" : "Recargar",
    "chooseOtherPay" : "Otros métodos de pago",
    "payIntro" : "Detalles de la recarga",
    "logRole" : "Seleccionar personaje",
    "chooseProduct" : "Seleccionar artículos",
    "meAgree" : "He leído y acepto los términos y condiciones.",
    "coinAgreeText" : "",
    "aboutCoin" : "",
    "coinsPayTokenLogin" : "Se necesita una verificación dinámica antes de utilizar el \${Z-BIT}",
    "dl3dvnVipRule1" : "1. Juegos disponibles: \${gameName}",
    "dl3dvnVipRule2" : "Cada tipo de recompensa del evento solo se puede reclamar una vez.",
    "dl3dvnVipRule3" : "2. Evento de cupón de inicio de sesión: Si inicias sesión por primera vez en la página de recarga, podrás reclamar un cupón de descuento del 15%.",
    "dl3dvnVipRule4" : "3. Evento \"Puntos VIP\": compra ítems en nuestra página oficial para ganar puntos y obtener cupones de nivel y semanales.",
    "dl3dvnVipRule5" : "4. Los puntos que obtengas pueden variar según la moneda que utilices. Para más detalles, consulta el enlace que aparece al final.",
    "dl3dvnVipRule6" : "5. Al usar los cupones, ganarás puntos según la cantidad que hayas pagado una vez descontados los cupones.",
    "dl3dvnVipRule7" : "6. Los puntos que hayas ganado caducarán en 365 días. Esto podría afectar tu nivel VIP.",
    "dl3dvnVipRule8" : "7. Recibirás un cupón por alcanzar un nivel VIP por primera vez. El cupón semanal se podrá reclamar todos los sábados a las 00:00 (UTC+0).",
    "dl3dvnVipRule9" : "8. Tendrás que iniciar sesión para poder reclamar el cupón semanal. ¡No te lo pierdas!",
    "dl3dvnVipRule10" : "9. La moneda del cupón será la del último pedido que hayas realizado. Ponte en contacto con el servicio de atención al cliente si deseas cambiar la moneda del cupón.",
    "dl3dvnVipRule11" : "10. Consulta la siguiente tabla para ver más detalles sobre los cupones y los niveles VIP.",
    "dl3dvnVipRule12" : "",
    "dl3dvnVipRule13" : "12. Si se produce algún conflicto, el equipo de asistencia de \${gameName} tendrá autoridad absoluta para interpretar las Condiciones Generales.",
    "codeTip7" : "No puedes usar el código del jugador objetivo porque ya has utilizado el tuyo",
    "ruleText10" : "10. La dirección oficial de Puzzles & Survival se reserva cualquier derecho de intervención final.",
    "payCoins" : "Recarga de Puntos VIP",
    "shareGift" : "Compartir a cambio de regalos",
    "attentionCoinUse" : "Note: The balance in each currency is handled separately.",
    "noPayWay" : "No hay métodos de pago disponibles en la región seleccionada. Cambia de región y vuelve a intentarlo.",
    "dl3dtwVipRule1" : "1. Juegos disponibles: \${gameName}",
    "dl3dtwVipRule2" : "Cada tipo de recompensa del evento solo se puede reclamar una vez.",
    "dl3dtwVipRule3" : "2. Evento \"Puntos VIP\": compra ítems en nuestra página oficial para ganar puntos y obtener cupones de nivel y semanales.",
    "dl3dtwVipRule4" : "3. Los puntos que obtengas pueden variar según la moneda que utilices. Para más detalles, consulta el enlace que aparece al final.",
    "dl3dtwVipRule5" : "4. Al usar los cupones, ganarás puntos según la cantidad que hayas pagado una vez descontados los cupones.",
    "dl3dtwVipRule6" : "5. Los puntos que hayas ganado caducarán en 365 días. Esto podría afectar tu nivel VIP.",
    "dl3dtwVipRule7" : "6. Recibirás un cupón por alcanzar un nivel VIP por primera vez. El cupón semanal se podrá reclamar todos los sábados a las 00:00 (UTC+0).",
    "dl3dtwVipRule8" : "7. Tendrás que iniciar sesión para poder reclamar el cupón semanal. ¡No te lo pierdas!",
    "dl3dtwVipRule9" : "8. La moneda del cupón será la del último pedido que hayas realizado. Ponte en contacto con el servicio de atención al cliente si deseas cambiar la moneda del cupón.",
    "dl3dtwVipRule10" : "9. Consulta la siguiente tabla para ver más detalles sobre los cupones y los niveles VIP.",
    "dl3dtwVipRule11" : "10. Si se produce algún conflicto, el equipo de asistencia de \${gameName} tendrá autoridad absoluta para interpretar las Condiciones Generales.",
    "eventInviteSucc" : "Invitar con éxito a un amigo",
    "eventGainCondition" : "Requisitos",
    "eventSuccInvite" : "Invitar con éxito a un amigo",
    "eventInviteGainOne" : "Recarga total de la \npersona invitada: \$49.99",
    "eventInviteGainTwo" : "Recarga total de la \npersona invitada: \$99.99",
    "eventFriendCode" : "Código de tu amigo:",
    "eventCheckBind" : "¿Vincular?",
    "eventConfirm" : "Confirmar",
    "eventCancel" : "Cancelar",
    "eventBindSucc" : "¡Vinculación exitosa!",
    "eventGainCoupon" : "Has obtenido un cupón.",
    "eventLookCoupon" : "Ver cupón",
    "eventSuccBind" : "Vinculación exitosa",
    "recaptchaTip" : "Verifica primero.",
    "completeRecaptcha" : "Completa la verificación captcha",
    "recaptchaExpired" : "La verificación ha caducado, inténtalo de nuevo",
    "inputAccountName" : "Ingresa la cuenta que deseas recuperar",
    "pwaPayTip" : "Acceso rápido, mejor experiencia",
    "pwsInstall" : "Añadir a la pantalla de inicio",
    "ztmslgType999" : "Cupón",
    "coinUseTips" : "Después de la compra, los cupones se enviarán al correo del juego. Los cupones se pueden usar para comprar artículos en el centro comercial de cupones del juego. Los cupones que se usen para comprar artículos contarán para tu recarga total.",
    "notice" : "Aviso",
    "popupConfirm" : "Confirmar",
    "hideWithinWeek" : "No volver a mostrar por 7 días",
    "ztmslgProductOffTips" : "Hemos recibido muchos comentarios sobre los cambios que pensábamos realizar en la página de pago a partir del 13 de marzo. Por este motivo, hemos decidido cancelar estos cambios y centrarnos en mejorar su experiencia de compra. Apreciamos sus opiniones y les agradecemos la comprensión y el apoyo que siguen brindándonos. Si tienen más preguntas, no duden en ponerse en contacto con nuestro equipo de atención al cliente.",
    "couponTopLimit" : "Importes máximos deducibles por divisa",
    "swsjpVipRule1" : "1. El evento empieza a las 00:00 (UTC) 24/03/2023",
    "swsjpVipRule2" : "2. Juegos disponibles: \${gameName}",
    "swsjpVipRule3" : "Cada tipo de recompensa del evento solo se puede reclamar una vez.",
    "swsjpVipRule4" : "3. Evento de cupón de inicio de sesión: Si inicias sesión por primera vez en la página de recarga, podrás reclamar un cupón de descuento del 15%.",
    "swsjpVipRule5" : "4. Evento \"Puntos VIP\": compra ítems en nuestra página oficial para ganar puntos y obtener cupones de nivel y semanales.",
    "swsjpVipRule6" : "5. Los puntos que obtengas pueden variar según la moneda que utilices. Para más detalles, consulta el enlace que aparece al final.",
    "swsjpVipRule7" : "6. Al usar los cupones, ganarás puntos según la cantidad que hayas pagado una vez descontados los cupones.",
    "swsjpVipRule8" : "7. Ya recibiste puntos por las compras que realizaste anteriormente.",
    "swsjpVipRule9" : "8. Los puntos que hayas ganado caducarán en 365 días. Esto podría afectar tu nivel VIP.",
    "swsjpVipRule10" : "9. Recibirás un cupón por alcanzar un nivel VIP por primera vez. El cupón semanal se podrá reclamar todos los sábados a las 00:00 (UTC+0).",
    "swsjpVipRule11" : "10. Tendrás que iniciar sesión para poder reclamar el cupón semanal. ¡No te lo pierdas!",
    "swsjpVipRule12" : "11. La moneda del cupón será la del último pedido que hayas realizado. Ponte en contacto con el servicio de atención al cliente si deseas cambiar la moneda del cupón.",
    "swsjpVipRule13" : "12. Si se produce algún conflicto, el equipo de asistencia de \${gameName} tendrá autoridad absoluta para interpretar las Condiciones Generales.",
    "beautyVipRule1" : "",
    "beautyVipRule2" : "",
    "beautyVipRule3" : "",
    "beautyVipRule4" : "",
    "beautyVipRule5" : "",
    "beautyVipRule6" : "",
    "beautyVipRule7" : "",
    "beautyVipRule8" : "",
    "beautyVipRule9" : "",
    "beautyVipRule10" : "",
    "beautyVipRule11" : "",
    "antslgType999" : "Cupón",
    "passAskMods" : "Preguntas al moderador",
    "passAskModsTip" : "Pregúntales a los moderadores cualquier duda que tengas sobre el juego",
    "passService" : "Consultas del cliente",
    "passServiceTip" : "Por cualquier consulta que tengas sobre la cuenta y la recarga, ponte en contacto con nuestro servicio de atención al cliente.",
    "passIKonw" : "OK",
    "passGoOn" : "Continuar",
    "voucherTitle" : "Centro oficial de recarga",
    "voucherAddHome" : "Añadir al escritorio",
    "voucherAddHomeTipOne" : "Pagos más rápidos, mejor experiencia",
    "voucherAddHomeTipTwo" : "Toca [Compartir] en la barra de herramientas",
    "voucherAddHomeTipThree" : "Selecciona [Añadir al escritorio]",
    "voucherLoginLook" : "Iniciar sesión para ver las ofertas",
    "voucherSwitchRole" : "Cambiar personaje",
    "voucherCoupon" : "Cupón",
    "voucherVip" : "Punto VIP",
    "voucherMoreCoupon" : "Más ofertas",
    "voucherAccountId" : "ID de la cuenta",
    "voucherOtp" : "Contraseña de un solo uso",
    "voucherOtherWayPay" : "Elige otra forma de pago",
    "voucherOtherLoginWay" : "Intenta otro método",
    "voucherCouponActivity" : "Descuentos",
    "voucherActivityNotBegin" : "El evento aún no comenzó.",
    "voucherGoCommunity" : "Recibe más información sobre los beneficios de las recargas en la comunidad",
    "voucherValidTime" : "Validez",
    "voucherLimitRegion" : "Solo en \${currency}",
    "voucherLiuyi" : "No hay cupones disponibles. Presta atención a futuros eventos.",
    "voucherPay" : "Comprar cupones",
    "voucherAbout" : "Sobre los cupones",
    "voucherChooseWay" : "Seleccionar método de pago",
    "voucherMoreWay" : "Más métodos de pago",
    "voucherChooseCoupon" : "Seleccionar cupón",
    "voucherHasChoose" : "Seleccionado",
    "voucherMoneyInsufficient" : "Saldo insuficiente",
    "voucherContact" : "Saldo insuficiente. Ponte en contacto con nuestro equipo de atención al cliente.",
    "voucherCouponTotal" : "Cupones disponibles",
    "voucherCouponTipGuide" : "Se podrá pagar con cupones después de seleccionar el medio de pago.",
    "voucherPaytypeNotSupport" : "Los cupones no están disponibles para esta forma de pago",
    "voucherTipSideOne" : "Los cupones se pueden canjear por todos los paquetes del juego y servicios con valor añadido, a excepción del propio cupón.",
    "voucherTipSideTwo" : "Hasta un 15% de descuento",
    "voucherYue" : "Saldo",
    "jpUidLoginName" : "",
    "jpUidToken" : "",
    "jpUidInputToken" : "",
    "pnsBook" : "Manual de supervivencia",
    "vipHeadText" : "Marco VIP exclusivo desbloqueado",
    "vipHeadGetText" : "Reclamar",
    "vipHeadGotText" : "Reclamado",
    "vipHeadGetTitle" : "Confirmar",
    "vipHeadGetTip" : "Esta recompensa solo se puede reclamar una vez por cuenta. ¿Continuar?",
    "vipHeadAwardText" : "Comandante de élite (permanente)",
    "vipHeadGetErrTip1" : "Falló. Inténtalo de nuevo o dirígete a Soporte técnico.",
    "cartGuideTipNew" : "Добавьте предметы, чтобы применить купон",
    "newVipTitle" : "Centro de recarga VIP",
    "newVipLogin" : "INICIAR SESIÓN",
    "newVipNowPoint" : "Puntos:",
    "newVipNextLevel" : "\${point} puntos para el siguiente nivel",
    "newVipUpgrade" : "ACTUALIZAR",
    "newVipLevel" : "Privilegios VIP",
    "newVipTip" : "Los cupones se actualizarán todos los sábados a las 00:00 (UTC). Los recibirás al iniciar sesión en la página oficial de recargas.",
    "newVipWeekly" : "Regalo semanal",
    "newVipReachPoint" : "Requisitos:",
    "newVipRuleInfo" : "Reglas:",
    "pleaseLang" : "Elija un idioma",
    "reference" : "Número de pedido",
    "saveToNext" : "Guardar los datos de la tarjeta.",
    "cardNum" : "Número de tarjeta",
    "expireTime" : "Vencimiento",
    "CVV" : "CVV",
    "pleaseCard" : "Tipo de tarjeta de crédito",
    "howToPay" : "¿Cómo quieres pagar?",
    "checkCard" : "Revisa los números de la tarjeta.",
    "checkExpiryDate" : "Revisa la fecha de vencimiento de la tarjeta.",
    "checkCVV" : "Revisa el código de seguridad de la tarjeta.",
    "addCard" : "Nuevo",
    "delete" : "Eliminar",
    "deleteCardTips" : "Borrar los datos guardados de la tarjeta.",
    "confirmDelete" : "Sí, eliminar",
    "cancelDelete" : "Cancelar",
    "checkAllCardMsg" : "Verifica que el número de tarjeta, la fecha de caducidad y el CVV sean correctos.",
    "leaveCreditPageTips" : "Если покинете страницу транзакция будет прервана. Хотите уйти?",
    "sureToLeave" : "Выйти",
    "continueToPay" : "Продолжить",
    "pushTest" : "Notificación de prueba",
    "getNoticication" : "¿No puede recibir las notificaciones del juego?",
    "waitCheckResult" : "Espera los resultados de la prueba.",
    "hadAbnormal" : "Hemos encontrado un error que podría estar causando estos fallos con las notificaciones.",
    "clickIntro" : "Toca el informe para ver cómo solucionarlo",
    "networkCheck" : "Prueba de red",
    "noticeAuthorityCheck" : "Prueba de acceso a la notificación",
    "noticeBtnCheck" : "Prueba de la barra de notificaciones",
    "gmsCheck" : "Prueba del servicio GMS",
    "batteryCheck" : "Prueba de la lista para optimizar la batería",
    "pushServiceCheck" : "Prueba del servicio de notificaciones",
    "reCheck" : "Probar de nuevo",
    "noNoticeAuthorityTip" : "Este dispositivo no tiene acceso a las notificaciones. Ve a Ajustes del sistema - Notificaciones para otorgarle el acceso al juego.",
    "noNoticeBtnTip" : "La barra de notificaciones está desactivada. Ve a Ajustes del sistema para activarla.",
    "noBatteryTip" : "Puede que no puedas recibir notificaciones porque el juego está incluido en la lista para optimizar la batería. Ve a Ajustes del sistema - Batería - Optimización de batería para eliminar al juego de esta lista.",
    "noPushServiceTip" : "El servidor de notificaciones no está conectado. Toca [Conectar] para reanudar el servicio.",
    "noNetworkTip" : "La conexión de red actual es inestable.",
    "noGmsTip" : "Tu dispositivo no es compatible con GMS. Utiliza un dispositivo que sí sea compatible.",
    "pushConnectFail" : "Servidor de notificaciones desconectado.",
    "pushConnectSucc" : "Servidor de notificaciones conectado.",
    "noGetPushTitle" : "Si aún no puedes recibir notificaciones del juego, sigue estos pasos:",
    "noGetPushContOne" : "1. Cierra el juego y vuelve a iniciar sesión en este dispositivo.",
    "noGetPushContTwo" : "2. Toca [Notificación de prueba] para comprobar si el dispositivo que se está usando actualmente puede recibir la notificación de prueba.",
    "noGetPushContThree" : "3. Si has recibido la notificación de prueba pero sigues sin poder recibir ninguna otra notificación, entonces ingresa al juego y ve a Ajustes - Notificaciones y revisa que todas las notificaciones estén activadas.",
    "noGetPushContFour" : "4. Si sigues sin poder recibir notificaciones, ponte en contacto con nuestro servicio de atención al cliente.",
    "getPushSucc" : "Tu dispositivo ha recibido una notificación de prueba. ¡El servicio está funcionando con normalidad!",
    "allCheckSucc" : "Prueba completada. ¡No se encontraron errores!",
    "pushCheck" : "Notificación de prueba",
    "useDirectPay" : "Utiliza el pago exprés",
    "paypalFraudnetInfo" : "Pago seguro a través de PayPal",
    "goToSetting" : "Ajustes",
    "retry" : "Reintentar",
    "connect" : "Conectar",
    "canRebind" : "Podrás volver a vincular después de desvincular",
    "agreePlatform" : "He aceptado los \${service} y \${privite}.",
    "sendGameNews" : "Suscribirse a los boletines informativos.",
    "canNotBindEmail" : "No podrás usar este correo para iniciar sesión una vez desvinculado.",
    "canNotBindPhone" : "No podrás usar este número de celular para iniciar sesión una vez desvinculado.",
    "canChangeByEmail" : "Puedes acceder con el correo en dispositivos diferentes.",
    "canChangeByPhone" : "Puedes acceder con el número de celular en dispositivos diferentes.",
    "loginSucc" : "Conectado",
    "phoneHadBind" : "El número de celular ya está vinculado. ¿Usarlo para iniciar sesión?",
    "emailHadBind" : "El correo ya está vinculado. ¿Usarlo para iniciar sesión?",
    "phoneNotBind" : "El número de celular aún no está vinculado. ¿Crear una cuenta nueva?",
    "emailNotBind" : "El correo aún no está vinculado. ¿Crear una cuenta nueva?",
    "emailAccount" : "Cuenta de correo electrónico",
    "phoneAccount" : "Cuenta del número celular",
    "phoneInputError" : "Número de celular no válido",
    "registerNewAccount" : "Registrarse",
    "secureTip" : "Consejos de seguridad para la cuenta",
    "toTop" : "Fijar en el principio",
    "createNewWork" : "Nuevo ticket",
    "serviceEvaluate" : "Calificar servicio",
    "emailRemind" : "Notificaciones",
    "isAgreeService" : "¿Qué opinas de nuestro servicio?",
    "thankEvaluateTop" : "¡Gracias por tu comentario!",
    "inputValidEmail" : "Ingresa un correo electrónico válido.",
    "replyWillRemind" : "Recibirás una notificación por correo cuando respondan a tu pregunta. Pulsa de nuevo para desactivarlo.",
    "isCancelEmailRemind" : "No recibirás notificaciones por correo. ¿Aún quieres desactivarlo?",
    "reconfirmEmail" : "Confirma tu dirección de correo electrónico.",
    "confirmCanSubmit" : "Confirmar para enviar el ticket",
    "serviceWillReply" : "Recibirás una notificación por correo cuando el servicio de atención al cliente haya respondido.",
    "cancelEmailRemind" : "¿Desactivar [notificaciones]?",
    "yes" : "Sí",
    "no" : "No",
    "inputWorkSearch" : "Buscar...",
    "loading" : "Cargando",
    "loadingError" : "Fallo la carga. Vuelve a cargar...",
    "noMore" : "Nada más",
    "cancelToTop" : "Descolgar",
    "evaluateOne" : "Muy malo",
    "evaluateTwo" : "Malo",
    "evaluateThree" : "Neutral",
    "evaluateFour" : "Bueno",
    "evaluateFive" : "Muy bueno",
    "confirmDelWorkTop" : "¿Borrar ticket?",
    "reRemindEmail" : "¿Necesitas una notificación por correo? Vuelve a pulsar el botón [Notificaciones].",
    "confirmWillReply" : "Confirma que aceptas recibir notificaciones por correo cuando el servicio de soporte envíe su respuesta.",
    "thankEvaluateBottom" : "",
    "confirmDelWorkBottom" : "Si se elimina, no se podrá recuperar.",
    "morePurchaseWay" : "",
    "purchaseNeed" : "",
    "videoUploadSucc" : "Video cargado",
    "videoUploadFail" : "No se pudo cargar el video",
    "videoUploadLimit" : "Sube un archivo mp4 con un tamaño inferior a 400MB y de no más de 2 minutos.",
    "imageUploadSucc" : "Imagen cargada",
    "imageUploadFail" : "No se pudo cargar la imagen",
    "uploading" : "Cargando",
    "smartOrderCreate" : "Ticket rápido",
    "smartOrderSearch" : "Buscar",
    "smartOrderComing" : "Próximamente",
    "smartOrderContactService" : "Atención al cliente",
    "smartOrderDetector" : "Asistente",
    "smartOrderDetect" : "Diagnosticar",
    "smartOrderDetecting" : "Diagnosticando",
    "smartOrderDetectTip" : "Se ha detectado un problema mientras jugabas. Toca Diagnosticar para que podamos identificarlo.",
    "smartOrderDetectTip2" : "Problema identificado. ¡Envíe un ticket para que podamos resolverlo!",
    "smartOrderSubmit" : "Enviar",
    "smartOrderIKnow" : "OK",
    "smartOrderConfirm" : "OK",
    "smartOrderLook" : "Ver",
    "smartOrderIsHelp" : "¿Te ha resultado útil este artículo?",
    "smartOrderInputQuestion" : "Escribe el problema que has encontrado.",
    "smartOrderPleaseInpt" : "Ingresar",
    "smartOrderPleaseChoose" : "Seleccionar",
    "smartOrderStoreTime" : "Tiempo de recarga",
    "smartOrderInputOrder" : "Ingresa el número del pedido",
    "smartOrderInputPrice" : "Ingresa el importe del pedido",
    "smartOrderNeedHelp" : "¿En qué puedo ayudarte?",
    "smartOrderLookHelpTip" : "Puedes revisar las preguntas frecuentes.",
    "smartOrderNoResult" : "No hay resultados. Prueba con otra palabra clave.",
    "smartOrderUpdateTime" : "Última edición",
    "smartOrderSelectStoreTime" : "Selecciona el tiempo de recarga",
    "smartOrderAtlestChoose" : "Rellena al menos uno",
    "workHomeTitle": "Centro de atención al cliente",
    "workHomeCurServer": "Servidor actual",
    "workHomeSearchPlaceholder": "Ingrese palabras clave para encontrar respuestas rápidamente",
    "workHomeSelfService": "Autoservicio",
    "workHomeAiService": "Servicio al cliente inteligente",
    "workHomeArtificialService": "Agente humano",
    "workHomeServiceEntrance": "Estamos a su servicio",
    "pwaInstallAward" : "Añadir acceso directo",
    "getMasonry" : "Reclamar diamante",
    "addToDrawerVisit" : "Añade un acceso directo para encontrarlo fácilmente.",
    "immeAddToGet" : "Añade un acceso directo para ganar premios limitados.",
    "add" : "Añadir acceso directo",
    "talkNextTime" : "Más tarde",
    "chooseRoleGetGift" : "Selecciona tu personaje para ganar recompensas",
    "getGiftSuccess" : "Reclamado. Ve a ver tus recompensas en el juego.",
    "dmaTitle" : "Anuncios personalizados",
    "dmaTitleSub" : "(opcional)",
    "newAdd" : "Nuevo",
    "smartDelete" : "Eliminar",
    "wordLengthTip" : "(0-600 personajes)",
    "areaLimitSwitchRegion" : "Cambiar región",
    "areaLimitCurrentRegionCurrency" : "Moneda y región actual",
    "areaLimitRegion" : "Región:",
    "areaLimitCurrency" : "Moneda:",
    "areaLimitNote" : "Nota:",
    "areaLimitSwitchLimitation" : "Cada cuenta puede cambiar de región una vez por año.",
    "areaLimitPostSwitchCoupon" : "Si cambias de región, la moneda de los nuevos cupones también cambiará.",
    "areaLimitRemainingSwitches" : "Intentos de cambio restantes: \${times}",
    "areaLimitNoRemainingSwitches" : "No hay intentos de cambio",
    "areaLimitUnableToSwitchThisYear" : "No puedes volver a cambiar de región este año.",
    "areaLimitCannotSwitch" : "No se puede cambiar",
    "areaLimitNavigateToSwitch" : "Cambiar",
    "areaLimitConfirmSwitch" : "Confirmar",
    "areaLimitPreSwitchRegionCurrency" : "Moneda y región actual",
    "areaLimitPostSwitchRegionCurrency" : "Moneda y región nuevas",
    "areaLimitPostSwitchRestriction" : "Una vez hecho, no se podrá volver a cambiar de región este año.",
    "areaLimitUnusedZBitWarning" : "Tienes Z-Bit sin usar y que no podrás utilizar si cambias de región. ¿Continuar?",
    "areaLimitConfirm" : "Confirmar",
    "areaLimitCancel" : "Cancelar",
    "areaLimitInconsistencyWarning" : "La región de acceso no coincide con la región de pago.",
    "areaLimitPromptToSwitch" : "¿Quieres cambiar de región?",
    "areaLimitEnterZipCode" : "*Please enter your zipcode",
    "areaLimitEnterInvalid" : "Zipcode is invalid, please re-enter",
    "areaLimitTaxRateTips" : "Depending on your location, the tax rate may vary, the payment amount shall prevail",
    "areaLimitInfoCollect" : "For information collection protection, please refer to the Privacy Policy",
    "getAward" : "Reclamar recompensa",
    "selectProductTitle" : "Seleccionar objeto",
    "hotSuggest" : "Lo mejor",
    "inputKeywordSearch" : "Buscar...",
    "lookProductContent" : "Detalles",
    "popupClose" : "Cerrar",
    "productSwitch" : "Cambiar",
    "confirmBuy" : "Comprar",
    "thinkLater" : "Más tarde",
    "areaLimitConfirmRegion" : "Confirmar região",
    "areaLimitContinuePay" : "Continuar a pagar",
    "areaLimitSwitchLimitationTwice" : "Cada conta pode mudar de região duas vezes por ano.",
    "dtmslgVipRule1" : "1. Juegos disponibles: \${gameName}",
    "dtmslgVipRule2" : "Cada tipo de recompensa del evento solo se puede reclamar una vez.",
    "dtmslgVipRule3" : "2. Evento \"Puntos VIP\": compra ítems en nuestra página oficial para ganar puntos y obtener cupones de nivel y semanales.",
    "dtmslgVipRule4" : "3. Los puntos que obtengas pueden variar según la moneda que utilices. Para más detalles, consulta el enlace que aparece al final.",
    "dtmslgVipRule5" : "4. Al usar los cupones, ganarás puntos según la cantidad que hayas pagado una vez descontados los cupones.",
    "dtmslgVipRule6" : "5. Los puntos que hayas ganado caducarán en 365 días. Esto podría afectar tu nivel VIP.",
    "dtmslgVipRule7" : "6. Recibirás un cupón por alcanzar un nivel VIP por primera vez. El cupón semanal se podrá reclamar todos los sábados a las 00:00 (UTC+0).",
    "dtmslgVipRule8" : "7. Tendrás que iniciar sesión para poder reclamar el cupón semanal. ¡No te lo pierdas!",
    "dtmslgVipRule9" : "8. La moneda del cupón será la del último pedido que hayas realizado. Ponte en contacto con el servicio de atención al cliente si deseas cambiar la moneda del cupón.",
    "dtmslgVipRule10" : "9. Consulta la siguiente tabla para ver más detalles sobre los cupones y los niveles VIP.",
    "dtmslgVipRule11" : "10. Si se produce algún conflicto, el equipo de asistencia de \${gameName} tendrá autoridad absoluta para interpretar las Condiciones Generales.",
    "dtmslgType10010" : "Descuento diario",
    "dtmslgType10020" : "Oferta Limitada",
    "dtmslgType10030" : "Héroe",
    "dtmslgType10040" : "Equipamiento",
    "dtmslgType10050" : "RUNA",
    "dtmslgType10060" : "Tótem",
    "dtmslgType10070" : "Piedra Sagrada",
    "dtmslgType10080" : "Dragón",
    "dtmslgType10090" : "Recursos",
    "dtmslgType10100" : "Construcción y tecnología",
    "dtmslgType10110" : "Raro",
    "dtmslgType10120" : "Curio",
    "dtmslgType10130" : "Diamante",
    "dtmslgType10140" : "Cupón",
    "dtmslgType2" : "Paquete de evento",
    "dtmslgType3" : "Centro de regalos",
    "dtmslgType4" : "Paquete emergente",
    "dtmslgType5" : "Paquete de pantalla principal",
    "dtmslgType20010" : "Paquete de Black Friday",
    "dtmslgType20021" : "Regalo de 5 días",
    "dtmslgTypeother" : "Other",
    "rightsIntro" : "",
    "213RightsIntro": "Pronto el evento \"Puntos VIP\" dejará de estar disponible debido a una actualización de funciones.<br/>\n" +
        "Asegúrate de utilizar los cupones que hayas obtenido en \"Puntos VIP\" antes de que caduquen.<br/>\n" +
        "Hora de finalización: 19/08/2024 08:00:00 (UTC)<br/>\n" +
        "Puedes visitar el Centro de Miembros Premium cuando termine el evento para disfrutar de más ventajas:<br/>\n" +
        "Completa las misiones para ganar puntos y canjearlos por cupones, objetos del juego y otras recompensas. Aprovecha las ventajas exclusivas para miembros y los sorteos.<br/>\n" +
        "¡No te pierdas los próximos premios y eventos!",
    "263RightsIntro": "Pronto el evento \"Puntos VIP\" dejará de estar disponible debido a una actualización de funciones.<br/>\n" +
        "Asegúrate de utilizar los cupones que hayas obtenido en \"Puntos VIP\" antes de que caduquen.<br/>\n" +
        "Hora de finalización: 28/09/2024 00:00:00 (UTC)<br/>\n" +
        "Puedes visitar el Centro de Miembros Premium cuando termine el evento para disfrutar de más ventajas:<br/>\n" +
        "Completa las misiones para ganar puntos y canjearlos por cupones, objetos del juego y otras recompensas. Aprovecha las ventajas exclusivas para miembros y los sorteos.<br/>\n" +
        "¡No te pierdas los próximos premios y eventos!",
    "goToRights" : "Dirígete al Centro de Miembros Premium",
    "oldVipIntro" : "Asegúrate de utilizar los cupones que hayas obtenido en \"Puntos VIP\" antes de que caduquen.",
    "pwa-20001" : "Primero debes iniciar sesión",
    "pwa-20002" : "Parámetro incorrecto",
    "pwa-20003" : "Designa un personaje",
    "pwa-20004" : "No se han podido enviar las recompensas. Inténtalo de nuevo o ponte en contacto con el servicio de atención al cliente.",
    "pwa-20005" : "Ya has reclamado la recompensa.",
    "pwa-20100" : "El evento no ha comenzado.",
    "pwa-20101" : "El evento ya terminó.",
    "pwa-20102" : "Aún no puedes reclamar las recompensas.",
    "pwa-20103" : "Tus recompensas han caducado.",
    "pwa-1001" : "Operación demasiado frecuente",
    "pwaCommon" : "¡Inténtalo de nuevo más tarde!",
    "zipCodeSwitchZipCode" : "Switch ZIP Code",
    "zipCodeState" : "state",
    "zipCodeRate" : "rate",
    "-" : "-",
    "officialStore": "Centro oficial de recargas",
    "headerSafeTip": "Seguro y libre de riesgos Transacción instantánea",
    "safeChecking": "... escaneando los medios de pago actuales",
    "safeChecked": "Uso seguro",
    "riskChecked": "Se ha detectado un riesgo potencial, procede con precaución",
    "footerSafeTitle1": "Seguro",
    "footerSafeTitle2": "Conveniente",
    "footerSafeTitle3": "Económico",
    "footerSafeTitle4": "Eficaz",
    "footerSafeContent1": "Centro oficial de recargas",
    "footerSafeContent2": "Compatible con varios métodos de pago",
    "footerSafeContent3": "Ofertas y más ventajas por tiempo limitado",
    "footerSafeContent4": "Transacción instantánea, sin demoras",
    "limitedTimeActivityTitle" : "Beneficios de tiempo limitado",
    "limitedTimeActivityTime" : "Duración del evento:  \${startDate} - \${endDate}（UTC）",
    "limitedTimeActivityTaskProcess" : "(Actualmente \${curPay}/\${targetPay})",
    "limitedTimeActivityRateTips" : "(Los tipos de cambio pueden variar. Consulta esta página para obtener información precisa)",
    "limitedTimeActivityNotAchieve" : "Sin completar",
    "limitedTimeActivityClaim" : "Reclamar",
    "limitedTimeActivityClaimed" : "Reclamado",
    "limitedTimeActivityTimeLeft" : "Tiempo limitado: \${days} d \${hours} h \${minutes} m \${seconds} s",
    "limitedTimeActivityRecord" : "Registros de reclamar",
    "limitedTimeActivityAward" : "Recompensas",
    "limitedTimeActivityGotTime" : "Veces en que se reclamó",
    "limitedTimeActivityGotRole" : "Personaje reclamado",
    "limitedTimeActivityRule" : "Reglas del evento",
    "limitedTimeActivity285Rule1" : "1. Duración del evento:  \${startDate} - \${endDate}（UTC）",
    "limitedTimeActivity285Rule2" : "2. Durante el evento, completa tareas de duración limitada para conseguir recompensas. Las tareas se clasifican en semanales y mensuales:",
    "limitedTimeActivity285Rule3" : "(1) Tareas semanales: Cada cuenta está limitada a completar una tarea semanal. El contador se reinicia cada lunes a las 0:00.",
    "limitedTimeActivity285Rule4" : "Tarea de inicio de sesión semanal: Durante el tiempo limitado, inicia sesión una vez en la página de inicio de sesión del sitio web oficial.",
    "limitedTimeActivity285Rule5" : "Recarga cualquier cantidad: Durante un tiempo limitado, puedes recargar cualquier cantidad a través de la página web oficial.",
    "limitedTimeActivity285Rule6" : "(2) Tareas mensuales: Cada cuenta está limitada a una tarea mensual, que se reinicia el día 1 de cada mes a las 0:00.",
    "limitedTimeActivity285Rule7" : "Tarea de inicio de sesión: Durante el tiempo limitado, inicia sesión una vez en la página de inicio de sesión del sitio web oficial.",
    "limitedTimeActivity285Rule8" : "Tarea de recargas acumulativas: Dentro del tiempo limitado, recarga la cantidad requerida para reclamar una recompensa una vez.",
    "limitedTimeActivity285Rule9" : "Nota: Debido a la larga duración del evento, los tipos de cambio pueden fluctuar. Consulte el importe mostrado en la página para conocer el importe de recarga.",
    "limitedTimeActivity285Rule10" : "3. Selecciona un personaje antes de reclamar una recompensa. Puedes encontrar tus recompensas dentro del juego después de reclamarlas.",
    "limitedTimeActivityClaimAward" : "Reclamar recompensa",
    "limitedTimeActivityConfirmGot" : "Confirmar para reclamar",
    "limitedTimeActivityGetSucc" : "Se reclamó con éxito",
    "limitedTimeActivityGetFail" : "Error al reclamar. Intenta de nuevo más tarde o contacta al servicio de atención al cliente.",
    "limitedTimeActivityFrequent" : "Evita las acciones frecuentes.",
    "limitedTimeActivityLoginFirst" : "Inicia sesión primero.",
    "limitedTimeActivityWrongParam" : "Error de parámetro",
    "limitedTimeActivityOverTips" : "El evento ha caducado. Actualiza la página.",
    "preRightsIntro" : "Pronto el evento \"Puntos VIP\" dejará de estar disponible debido a una actualización de funciones.<br/>Hora de finalización: \${offLineDate}<br/>Asegúrate de utilizar los cupones que hayas obtenido en \"Puntos VIP\" antes de que caduquen.<br/>Puedes visitar el Centro de Miembros Premium cuando termine el evento para disfrutar de más ventajas:<br/>Completa las misiones para ganar puntos y canjearlos por cupones, objetos del juego y otras recompensas. Aprovecha las ventajas exclusivas para miembros y los sorteos.<br/>¡No te pierdas los próximos premios y eventos!",
    "riskTipTitle" : "Cuidado con las estafas y las prácticas ilegales",
    "riskTipContent" : "Queridos jugadores,\n\nHemos notado que algunas personas realizan acciones que alteran el orden y la imparcialidad del juego. Estas son algunas de las infracciones más comunes:\n\n1. Publicar anuncios no autorizados: Comparten anuncios no autorizados en los chats del juego u otros canales para fomentar la venta ilegal de recursos o recargas no autorizadas.\n2. Usar trampas o scripts del juego: Usan trampas, scripts u otros métodos para obtener recursos de manera ilegal.\n3. Invitaciones sospechosas: Envían invitaciones para que los jugadores entren a canales externos (ejemplo, Line, Discord).\n4. Recargas ilegales: Venden recargas no oficiales con descuentos para engañar a los jugadores.\n5. Otros tipos de estafas: Realizan actividades fraudulentas, como hacerse pasar por personal oficial.\n\nLes pedimos que protejan su información personal y sus recursos. No confíen en ningún mensaje sospechoso o que esté relacionado con estas estafas. Estas infracciones implican riesgos importantes, como el robo de cuentas o la participación en actividades fraudulentas. Tengan en cuenta que no ofreceremos ningún tipo de compensación por las pérdidas que se deriven de estas acciones.\n\nLas cuentas que incurran en este tipo de comportamiento serán sancionadas tomando en cuenta la gravedad y el impacto de las infracciones. Algunas medidas pueden ser advertencias, confiscación de ganancias ilegales, y suspensiones temporales o permanentes, entre otras. Si detectan algún comportamiento sospechoso en el juego, contacten al equipo de atención al cliente. Investigaremos tan pronto como sea posible y tomaremos las medidas necesarias. Gracias por comprender y apoyarnos.",
    "linkValid": "El enlace ha caducado",
    "-" : "-",
    "accountLabel": "Cuenta",
    "passwordLabel": "Contraseña",
    "confirmPasswordLabel": "Confirmar contraseña",
    "confirmDeleteTitle" : "¿De verdad quieres eliminar tu cuenta y todos los personajes?",
    "confirmDeleteYes" : "Sí, quiero eliminar mi cuenta y todos los personajes.",
    "selectGame" : "Seleccionar juego",
    "confirmDeleteNo" : "No. Solo quiero eliminar un personaje, quiero mantener mi cuenta.",
    "delTermsTitle" : "Lee atentamente los requisitos y el aviso para eliminar la cuenta.",
    "delCondTitle" : "1. Requisitos para eliminar la cuenta",
    "delCond1" : "(1) Accede a tu cuenta antes de enviar la solicitud. Si no puedes ingresar, deberás [recuperar tu cuenta] primero. Verifica que la cuenta y el personaje sean tuyos.",
    "delCond2" : "(2) Revisa que tu cuenta y tu personaje no tengan <span>riesgos de seguridad</span>, como quejas, reportes, investigaciones, arbitrajes o denuncias pendientes (iniciadas por ti o en tu contra).",
    "delCond3" : "(3) Revisa que tu cuenta y tu personaje no tengan <span>pagos pendientes</span>, como reembolsos sin resolver o suscripciones activas.",
    "delNoticeTitle" : "2. Aviso para eliminar la cuenta",
    "delNotice1" : "(1) Esta cuenta y los personajes correspondientes serán eliminados de forma <span>permanente e irreversible</span>.",
    "delNotice2" : "(2) Antes de continuar, <span>gestiona los recursos que queden pendientes</span> en el juego (como los objetos, monedas y suscripciones, entre otros), ya que serán eliminados de forma permanente al borrarse la cuenta. No se realizarán reembolsos a cuentas o personajes eliminados cuando se cierre el servidor.",
    "delNotice3" : "(3) Si se eliminan los datos de la cuenta y de los personajes, también se eliminará o se hará anónima toda la información relacionada. Sin embargo, tendrás que desvincular y gestionar manualmente los datos asociados a las redes sociales externas (por ejemplo, Facebook).",
    "delNotice4" : "(4) Se te concederá un período de espera de 14 días (período de enfriamiento) para proteger tus datos (excepto en los casos en que las normativas locales difieran). Durante este tiempo, podrás ponerte en contacto con el servicio de atención al cliente para cancelar la solicitud de eliminación.",
    "delNotice5" : "(5) Una vez completada la solicitud, tu cuenta se congelará inmediatamente, pero es posible que los datos se borren en un plazo de hasta una semana. Recibirás una notificación por correo electrónico una vez completado el proceso.",
    "delFormConfirm1" : "Entiendo los requisitos y las consecuencias de borrar mi cuenta.",
    "delFormConfirm2" : "Esta cuenta no tiene ninguna denuncia pendiente.",
    "delForm" : "He leído y aceptado el <a class=\"account-delete-link\" href=\"javascript:;\">Acuerdo de eliminación de la cuenta</a>.",
    "cannotDeleteMsgTitle" : "No se puede eliminar la cuenta",
    "cannotDeleteMsg1" : "No se cumplen los requisitos para eliminar tu cuenta:",
    "cannotDeleteMsg2" : "Tienes tickets de ayuda sin resolver. Te rogamos que los gestiones antes de presentar otra solicitud.",
    "cannotDeleteMsg3" : "Tienes reintegros pendientes. Resuélvelos antes de eliminar tu cuenta.",
    "cannotDeleteMsg4" : "Estamos revisando tu cuenta por los reportes o quejas de otros jugadores. Espera a que termine la revisión antes de enviar otra solicitud.",
    "formCompleted" : "Ticket enviado",
    "formCheckMsg1" : "Tu ticket ha sido enviado, espera la revisión y la respuesta.",
    "formCheckMsg2" : "Puedes revisar el progreso del ticket en <span class=\"account-delete-link\">[Mis tickets]</span>.",
    "delEmailMsg1" : "¿Enviar notificación por correo después de la eliminación?",
    "delEmailMsg2" : "Se eliminará la cuenta en aproximadamente una semana para poder procesar los datos. ¿Quieres recibir una notificación por correo una vez finalizado?",
    "delEmailMsg3" : "Tu correo electrónico solo se usará para enviar notificaciones.",
    "delEmailConfirmYes" : "Sí, enviarme una notificación.",
    "delEmailFill" : "Ingresa tu correo electrónico para recibir la notificación.",
    "delEmailConfirmNo" : "No, no quiero recibir notificaciones.",
    "delCoolMsg1" : "¿Deseas el periodo de enfriamiento de 14 días?",
    "delCoolMsg2" : "Durante el periodo de espera de 14 días, tu cuenta se congelará, pero podrás enviar una solicitud para cancelar la eliminación en cualquier momento. Transcurridos los 14 días, si no has cancelado, tu cuenta se eliminará y no podrás recuperarla.",
    "delCoolMsg3" : "Si decides prescindir del periodo de enfriamiento, tu cuenta se eliminará inmediatamente después de completar la solicitud y no se podrá recuperar.",
    "delCoolConfirmYes" : "Sí, necesito un periodo de enfriamiento de 14 días.",
    "delCoolConfirmNo" : "No, bórralo ahora.",
    "delSecondCheckMsg1" : "¿Estás seguro de que has gestionado todo el contenido de la cuenta y quieres activar el periodo de enfriamiento? No podrás acceder a tu cuenta una vez activado este periodo.",
    "delSecondCheckConfirmYes" : "Sí, actívalo ahora.",
    "delResMsg1" : "Se ha enviado la solicitud para eliminar la cuenta y se ha congelado la siguiente cuenta:",
    "gameName" : "Nombre del juego:",
    "gameAccount" : "Cuenta del juego:",
    "delResMsg2" : "<span>Haz una captura de pantalla y guarda la información de la cuenta anterior, ya que es la única manera de verificar si necesitas restaurar la cuenta durante el periodo de enfriamiento.</span>.",
    "delResMsg3" : "periodo de enfriamiento: 14 días. Tiempo restante:",
    "delResMsg4" : "Para cancelar la solicitud de eliminación durante el periodo de enfriamiento, haz clic en [Contactar al soporte técnico].",
    "copyAccountInfo" : "Copiar la información de la cuenta",
    "delResMsg5" : "Hemos procesado tu solicitud y estamos eliminando tu cuenta. Ya no podrás iniciar sesión con ella.",
    "delResMsg6" : "La eliminación de una cuenta requiere tiempo debido a la gran cantidad de datos que se procesan. Por lo tanto, no se borrarán inmediatamente todos los rastros de tu cuenta. Esperamos completar este proceso en el plazo aproximado de una semana.",
    "delResMsg7" : "Si ya nos has indicado un correo electrónico para recibir las notificaciones, te enviaremos un mensaje a esa dirección.",
    "delResMsg8" : "Si deseas volver a entrar en el juego, puedes crear una cuenta nueva.",
    "appleOption" : "App Store",
    "googleOption" : "Google Play",
    "otherOption" : "Otros canales",
    "itemWrong" : "Se produjo un error al ingresar la información. Inténtalo de nuevo.",
    "delRegisterTime" : "Fecha de inscripción",
    "delDevice" : "Dispositivo de uso frecuente",
    "delIp" : "Dirección IP de uso frecuente",
    "delHistoryPayChannel" : "Canales de Recarga Históricos",
    "delHistoryPayOrder" : "Números de pedidos anteriores",
    "delDeleteReason" : "Motivo de la eliminación de la cuenta",
    "delPrevStep" : "Anterior",
    "delNextStep" : "Próximo",
    "delSecondCheckMsg2" : "¿Estás seguro de que has gestionado todo el contenido de la cuenta y de que está lista para ser eliminada? Una vez hecho esto, ya no se podrá acceder a tu cuenta.",
    "pleaseFillIn" : "Proporciona la siguiente información",
    "switchNewVersion": "Cambiar a la nueva",
    "switchNewVersionPlatform": "plataforma de pago",
    "updateVersionPopupContent": "Para asegurar un rendimiento fluido del juego y el soporte de nuevas funciones, recomendamos actualizar el sistema del dispositivo para disfrutar de una experiencia de funcionamiento más estable y una optimización de compatibilidad.",
    selectTopupTips:"El 90% de los jugadores elige el centro de recarga oficial",
    chuzhi: "Recarga",
    selectMethods: "Método de pago",
    landscapeTip2: "Por favor, gire su teléfono al modo vertical para una mejor experiencia",
    v3LaunchFromDesktopAndRewardToMailbox: 'Por favor, inicie desde el escritorio\nSeleccione un personaje y la recompensa se enviará al buzón',
    ckoNotAvailable: 'Error en el servicio de pago, inténtelo de nuevo más tarde.',
    ckoSubmitFail: 'Pago fallido. Por favor, verifique su información o use otra tarjeta. Si se ha realizado el cargo, se reembolsará al método de pago original.',
    gotoFinish: 'Pendiente',
    inAppPurchase: 'Compra dentro de la aplicación',
}